
// import React, { useEffect, useState } from "react";
// import axiosInstance from "../../utils/axiosInstance";
// import { BASE_URL } from "../../config";
// import "./Engineer.css";

// // ─── Salary Slip Generator ────────────────────────────────────────────────────
// function generateSalarySlipHTML(eng, h) {
//   const month = h.paymentMonth || "—";
//   const today = new Date().toLocaleDateString("en-IN", { day: "2-digit", month: "long", year: "numeric" });

//   return `<!DOCTYPE html>
// <html lang="en">
// <head>
// <meta charset="UTF-8"/>
// <title>Salary Slip – ${eng.name} – ${month}</title>
// <style>
//   @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display&family=DM+Sans:wght@400;500;600&display=swap');
//   *{box-sizing:border-box;margin:0;padding:0}
//   body{font-family:'DM Sans',sans-serif;background:#f4f4f0;display:flex;justify-content:center;padding:40px 16px}
//   .slip{background:#fff;width:720px;border-radius:4px;overflow:hidden;box-shadow:0 2px 16px rgba(0,0,0,.10)}
//   .header{background:#1a1a2e;color:#fff;padding:32px 40px;display:flex;justify-content:space-between;align-items:flex-start}
//   .company{font-family:'DM Serif Display',serif;font-size:22px;letter-spacing:.5px;margin-bottom:4px}
//   .header-sub{font-size:12px;opacity:.6;line-height:1.6}
//   .slip-label{text-align:right}
//   .slip-label .title{font-size:13px;letter-spacing:2px;text-transform:uppercase;opacity:.6;margin-bottom:6px}
//   .slip-label .month{font-family:'DM Serif Display',serif;font-size:20px}
//   .divider-bar{height:4px;background:linear-gradient(90deg,#e8b86d 0%,#c97d4e 100%)}
//   .body{padding:32px 40px}
//   .emp-section{display:grid;grid-template-columns:1fr 1fr;gap:16px 32px;margin-bottom:28px;padding-bottom:24px;border-bottom:1px solid #ebebeb}
//   .field label{font-size:10px;text-transform:uppercase;letter-spacing:1.5px;color:#999;display:block;margin-bottom:3px}
//   .field span{font-size:14px;color:#1a1a2e;font-weight:500}
//   .earnings-table{width:100%;border-collapse:collapse;margin-bottom:24px}
//   .earnings-table th{font-size:10px;text-transform:uppercase;letter-spacing:1.5px;color:#999;text-align:left;padding:8px 12px;background:#f9f9f7;border-bottom:2px solid #ebebeb}
//   .earnings-table td{padding:10px 12px;font-size:13px;color:#333;border-bottom:1px solid #f0f0f0}
//   .earnings-table tr:last-child td{border-bottom:none}
//   .earnings-table .amount{text-align:right;font-weight:500}
//   .total-row{background:#1a1a2e!important}
//   .total-row td{color:#fff!important;font-weight:600!important;font-size:14px!important;padding:14px 12px!important;border:none!important}
//   .status-section{display:flex;justify-content:space-between;align-items:center;background:#f9f9f7;border-radius:4px;padding:16px 20px;margin-bottom:24px}
//   .status-section .label{font-size:11px;text-transform:uppercase;letter-spacing:1.5px;color:#999;margin-bottom:4px}
//   .status-section .value{font-size:15px;font-weight:600;color:#1a1a2e}
//   .badge{display:inline-block;padding:4px 12px;border-radius:20px;font-size:11px;font-weight:600;letter-spacing:.5px;text-transform:uppercase}
//   .badge-paid{background:#e6f4ea;color:#2e7d32}
//   .badge-pending{background:#fff3f3;color:#e53935}
//   .remarks-box{background:#fffbf0;border-left:3px solid #e8b86d;padding:12px 16px;font-size:13px;color:#666;margin-bottom:24px;border-radius:0 4px 4px 0}
//   .footer{border-top:1px solid #ebebeb;padding:20px 40px;display:flex;justify-content:space-between;font-size:11px;color:#bbb;background:#fafafa}
//   .sig{text-align:right}
//   .sig-line{width:140px;border-top:1px solid #ccc;margin:28px 0 4px auto}
//   .sig-label{font-size:10px;text-transform:uppercase;letter-spacing:1px;color:#999}
//   @media print{body{background:#fff;padding:0}button{display:none!important}.slip{box-shadow:none}}
// </style>
// </head>
// <body>
// <div class="slip">
//   <div class="header">
//     <div>
//       <div class="company">Nagpur Properties</div>
//       <div class="header-sub">Nagpur, Maharashtra, India<br/></div>
//     </div>
//     <div class="slip-label">
//       <div class="title">Salary Slip</div>
//       <div class="month">${month}</div>
//     </div>
//   </div>
//   <div class="divider-bar"></div>
//   <div class="body">
//     <!-- Employee Info -->
//     <div class="emp-section">
//       <div class="field"><label>Employee Name</label><span>${eng.name || "—"}</span></div>
//       <div class="field"><label>Designation</label><span>${eng.designation || "—"}</span></div>
//       <div class="field"><label>Email</label><span>${eng.email || "—"}</span></div>
//       <div class="field"><label>Phone</label><span>${eng.phoneNumber || "—"}</span></div>
//       <div class="field"><label>Payment Month</label><span>${month}</span></div>
//       <div class="field"><label>Generated On</label><span>${today}</span></div>
//     </div>

//     <!-- Earnings Table -->
//     <table class="earnings-table">
//       <thead>
//         <tr>
//           <th>Component</th>
//           <th>Details</th>
//           <th class="amount">Amount (₹)</th>
//         </tr>
//       </thead>
//       <tbody>
//         <tr>
//           <td>Basic Salary (Monthly)</td>
//           <td>${h.daysWorked} days × ₹${h.salaryPerDay}/day</td>
//           <td class="amount">₹ ${(h.totalAmountPayable || 0).toLocaleString("en-IN")}</td>
//         </tr>
//         <tr>
//           <td>Amount Paid</td>
//           <td>Disbursed</td>
//           <td class="amount" style="color:#2e7d32">₹ ${(h.amountPaid || 0).toLocaleString("en-IN")}</td>
//         </tr>
//         <tr>
//           <td>Pending Amount</td>
//           <td>Balance due</td>
//           <td class="amount" style="color:#e53935">₹ ${(h.pendingAmount || 0).toLocaleString("en-IN")}</td>
//         </tr>
//         <tr class="total-row">
//           <td colspan="2">Net Payable</td>
//           <td class="amount">₹ ${(h.totalAmountPayable || 0).toLocaleString("en-IN")}</td>
//         </tr>
//       </tbody>
//     </table>

//     <!-- Status -->
//     <div class="status-section">
//       <div>
//         <div class="label">Payment Status</div>
//         <div class="value">${h.paymentStatus === "PAID" ? "Fully Paid" : "Pending / Partial"}</div>
//       </div>
//       <span class="badge ${h.paymentStatus === "PAID" ? "badge-paid" : "badge-pending"}">
//         ${(h.paymentStatus || "").replace(/_/g, " ")}
//       </span>
//     </div>

//     ${h.remarks ? `<div class="remarks-box"><strong>Remarks:</strong> ${h.remarks}</div>` : ""}

//     <!-- Signature -->
//     <div class="sig">
//       <div class="sig-line"></div>
//       <div class="sig-label">Authorised Signatory</div>
//     </div>
//   </div>
//   <div class="footer">
//     <span>This is a computer-generated salary slip and does not require a physical signature.</span>
//     <span>Nagpur Properties © ${new Date().getFullYear()}</span>
//   </div>
// </div>
// </body>
// </html>`;
// }

// function downloadSalarySlip(eng, h) {
//   const html = generateSalarySlipHTML(eng, h);
//   const blob = new Blob([html], { type: "text/html" });
//   const url = URL.createObjectURL(blob);
//   const a = document.createElement("a");
//   a.href = url;
//   a.download = `SalarySlip_${(eng.name || "Engineer").replace(/\s+/g, "_")}_${h.paymentMonth || "unknown"}.html`;
//   document.body.appendChild(a);
//   a.click();
//   document.body.removeChild(a);
//   URL.revokeObjectURL(url);
// }
// // ─────────────────────────────────────────────────────────────────────────────

// function Engineer() {
//   const token = JSON.parse(localStorage.getItem("NagpurProperties"))?.token;

//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [editEngineerId, setEditEngineerId] = useState(null);
//   const [engineerList, setEngineerList] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [submitting, setSubmitting] = useState(false);

//   const [statusFilter, setStatusFilter] = useState("ALL");
//   const [statusModal, setStatusModal] = useState(null);
//   const [selectedStatus, setSelectedStatus] = useState("WORKING");
//   const [statusSubmitting, setStatusSubmitting] = useState(false);
//   const [deleteModal, setDeleteModal] = useState(null);
//   const [deleteSubmitting, setDeleteSubmitting] = useState(false);

//   // ── Payment History Modal ──
//   const [historyModal, setHistoryModal] = useState(null); // { id, name, email, phoneNumber, designation }
//   const [historyData, setHistoryData] = useState([]);
//   const [historyLoading, setHistoryLoading] = useState(false);

//   // ── Check Salary Modal ──
//   const [checkSalaryModal, setCheckSalaryModal] = useState(null);
//   const [checkSalaryMonth, setCheckSalaryMonth] = useState("");
//   const [checkSalaryData, setCheckSalaryData] = useState(null);
//   const [checkSalaryLoading, setCheckSalaryLoading] = useState(false);

//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phoneNumber: "",
//     password: "",
//     bloodGroup: "",
//     panNumber: "",
//     aadharNumber: "",
//     emergencyContact: "",
//     designation: "",
//     salaryPerMonth: "",
//     address: "",
//     dateOfJoining: "",
//     dateOfBirth: "",
//     lastWorkingDate: "",
//     engineerStatus: "WORKING",
//   });

//   const [aadharFile, setAadharFile] = useState(null);
//   const [resumeFile, setResumeFile] = useState(null);

//   // ─── HELPERS ─────────────────────────────────
//   const initials = (name = "") =>
//     name.trim().split(" ").slice(0, 2).map((w) => w[0]?.toUpperCase() || "").join("");

//   const filteredList = engineerList.filter((e) => {
//     const matchesSearch =
//       (e.name || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
//       (e.email || "").toLowerCase().includes(searchQuery.toLowerCase());
//     const matchesStatus =
//       statusFilter === "ALL" || e.engineerStatus === statusFilter;
//     return matchesSearch && matchesStatus;
//   });

//   const stats = {
//     total: engineerList.length,
//     active: engineerList.filter((e) => e.engineerStatus === "WORKING").length,
//     designations: new Set(engineerList.map((e) => e.designation).filter(Boolean)).size,
//   };

//   const statusLabel = (status) => {
//     if (!status || status === "WORKING") return "Working";
//     return status.replace("NOT_WORKING_", "").replace(/_/g, " ");
//   };

//   const formatStatus = (status) => status ? status.replace(/_/g, " ") : "-";

//   // ─── FORM HANDLERS ───────────────────────────
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const resetForm = () => {
//     setFormData({
//       name: "", email: "", phoneNumber: "", password: "",
//       bloodGroup: "", panNumber: "", aadharNumber: "",
//       emergencyContact: "", designation: "", salaryPerMonth: "",
//       address: "", dateOfJoining: "", dateOfBirth: "",
//       lastWorkingDate: "", engineerStatus: "WORKING",
//     });
//     setAadharFile(null);
//     setResumeFile(null);
//     setEditEngineerId(null);
//     setDrawerOpen(false);
//   };

//   useEffect(() => {
//     if (formData.lastWorkingDate) {
//       setFormData((prev) => ({ ...prev, engineerStatus: "NOT_WORKING_RESIGNED" }));
//     }
//   }, [formData.lastWorkingDate]);

//   const buildRegisterFormData = () => {
//     const data = new FormData();
//     const dto = {};
//     Object.keys(formData).forEach((key) => {
//       if (formData[key] !== "" && formData[key] !== null && formData[key] !== undefined)
//         dto[key] = formData[key];
//     });
//     data.append("engineerDto", new Blob([JSON.stringify(dto)], { type: "application/json" }));
//     if (aadharFile) data.append("aadharCardImg", aadharFile);
//     if (resumeFile) data.append("resume", resumeFile);
//     return data;
//   };

//   const buildUpdateFormData = () => {
//     const data = new FormData();
//     const { engineerStatus, ...rest } = formData;
//     const dto = {};
//     Object.keys(rest).forEach((key) => {
//       if (rest[key] !== "" && rest[key] !== null && rest[key] !== undefined)
//         dto[key] = rest[key];
//     });
//     data.append("request", new Blob([JSON.stringify(dto)], { type: "application/json" }));
//     data.append("engineerStatus", new Blob([JSON.stringify(engineerStatus)], { type: "application/json" }));
//     if (aadharFile) data.append("aadharCardImg", aadharFile);
//     if (resumeFile) data.append("resume", resumeFile);
//     return data;
//   };

//   // ─── API CALLS ───────────────────────────────
//   async function getEngineerList() {
//     try {
//       const response = await axiosInstance.get(`${BASE_URL}/allEngineers`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setEngineerList(response.data.sort((a, b) => b.id - a.id));
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   }

//   async function fetchEngineerById(id) {
//     try {
//       const response = await axiosInstance.get(`${BASE_URL}/engineer/${id}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       return response.data;
//     } catch (error) {
//       console.error(error);
//       alert("Failed to fetch engineer details");
//       return null;
//     }
//   }

//   // ── Payment History ───────────────────────────
//   async function openHistoryModal(eng) {
//     // Store full engineer info for salary slip generation
//     setHistoryModal({
//       id: eng.id,
//       name: eng.name,
//       email: eng.email,
//       phoneNumber: eng.phoneNumber,
//       designation: eng.designation,
//     });
//     setHistoryData([]);
//     setHistoryLoading(true);
//     try {
//       const response = await axiosInstance.get(
//         `${BASE_URL}/engineer/${eng.id}/payment/history`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       setHistoryData(response.data);
//     } catch (error) {
//       console.error(error);
//       alert(error?.response?.data?.message || "Failed to fetch payment history");
//       setHistoryModal(null);
//     } finally {
//       setHistoryLoading(false);
//     }
//   }

//   // ── Check Salary ──────────────────────────────
//   function openCheckSalaryModal(eng) {
//     setCheckSalaryModal({ id: eng.id, name: eng.name });
//     setCheckSalaryMonth("");
//     setCheckSalaryData(null);
//   }

//   async function handleCheckSalary() {
//     if (!checkSalaryMonth) { alert("Please select a month"); return; }
//     const formattedMonth = checkSalaryMonth.slice(0, 7) + "-01";
//     setCheckSalaryLoading(true);
//     setCheckSalaryData(null);
//     try {
//       const response = await axiosInstance.post(
//         `${BASE_URL}/engineer/${checkSalaryModal.id}/payment/generate`,
//         null,
//         {
//           params: {
//             engineerId: checkSalaryModal.id,
//             paymentMonth: formattedMonth,
//           },
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       setCheckSalaryData(response.data);
//     } catch (error) {
//       console.error(error);
//       alert(error?.response?.data?.message || "Failed to fetch salary info");
//     } finally {
//       setCheckSalaryLoading(false);
//     }
//   }

//   async function handleAddEngineer(e) {
//     e.preventDefault();
//     setSubmitting(true);
//     try {
//       const response = await axiosInstance.post(
//         `${BASE_URL}/registerEngineer`,
//         buildRegisterFormData(),
//         { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
//       );
//       if (response.status === 200) {
//         alert("Engineer Registered Successfully");
//         resetForm();
//         getEngineerList();
//       }
//     } catch (error) {
//       let message = "Something went wrong";
//       if (error.response) {
//         const { status, data } = error.response;
//         if (status === 409) message = data?.message || "Email already exists";
//         else if (status === 400) message = data?.message || "Invalid data";
//         else if (status === 401) message = "Unauthorized. Please login again.";
//         else if (status === 500) message = data?.message || "Server error. Try again later.";
//         else message = data?.message || `Error: ${status}`;
//       } else if (error.request) {
//         message = "No response from server. Check your connection.";
//       } else {
//         message = error.message;
//       }
//       alert(message);
//     } finally {
//       setSubmitting(false);
//     }
//   }

//   async function handleEditEngineerRegistration(e) {
//     e.preventDefault();
//     setSubmitting(true);
//     try {
//       const response = await axiosInstance.put(
//         `${BASE_URL}/engineer/update/${editEngineerId}`,
//         buildUpdateFormData(),
//         { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
//       );
//       if (response.status === 200) {
//         alert("Engineer Updated Successfully");
//         resetForm();
//         getEngineerList();
//       }
//     } catch (error) {
//       alert(error?.response?.data?.message || "Update failed");
//     } finally {
//       setSubmitting(false);
//     }
//   }

//   async function handleDeleteEngineer() {
//     setDeleteSubmitting(true);
//     try {
//       const response = await axiosInstance.delete(
//         `${BASE_URL}/deleteEngineer/${deleteModal.id}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       if (response.status === 200) {
//         alert("Engineer Deleted Successfully");
//         setDeleteModal(null);
//         getEngineerList();
//       }
//     } catch (error) {
//       alert(error?.response?.data?.message || "Delete failed");
//     } finally {
//       setDeleteSubmitting(false);
//     }
//   }

//   function openStatusModal(eng) {
//     setStatusModal({ id: eng.id, name: eng.name });
//     setSelectedStatus(eng.engineerStatus || "WORKING");
//   }

//   async function handleStatusUpdate() {
//     setStatusSubmitting(true);
//     try {
//       const response = await axiosInstance.patch(
//         `${BASE_URL}/engineer/update/${statusModal.id}/status?engineerStatus=${selectedStatus}`,
//         null,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       if (response.status === 200) {
//         alert("Status Updated Successfully");
//         setStatusModal(null);
//         getEngineerList();
//       }
//     } catch (error) {
//       alert(error?.response?.data?.message || "Status update failed");
//     } finally {
//       setStatusSubmitting(false);
//     }
//   }

//   async function openEditDrawer(engineer) {
//     const data = await fetchEngineerById(engineer.id);
//     if (!data) return;
//     setEditEngineerId(data.id);
//     setFormData({
//       name: data.name || "",
//       email: data.email || "",
//       phoneNumber: data.phoneNumber || "",
//       password: "",
//       bloodGroup: data.bloodGroup || "",
//       panNumber: data.panNumber || "",
//       aadharNumber: data.aadharNumber || "",
//       emergencyContact: data.emergencyContact || "",
//       designation: data.designation || "",
//       salaryPerMonth: data.salaryPerMonth != null ? String(data.salaryPerMonth) : "",
//       address: data.address || "",
//       dateOfJoining: data.dateOfJoining || "",
//       dateOfBirth: data.dateOfBirth || "",
//       lastWorkingDate: data.lastWorkingDate || "",
//       engineerStatus: data.engineerStatus || "WORKING",
//     });
//     setDrawerOpen(true);
//   }

//   useEffect(() => { getEngineerList(); }, []);

//   // ─── RENDER ──────────────────────────────────
//   return (
//     <div className="eng-page">

//       {/* TOP BAR */}
//       <div className="eng-topbar">
//         <div>
//           <h2 className="eng-page-title">Engineers</h2>
//           <p className="eng-page-sub">Manage your engineering team</p>
//         </div>
//         <button className="eng-btn-primary" onClick={() => { resetForm(); setDrawerOpen(true); }}>
//           + Add engineer
//         </button>
//       </div>

//       {/* STAT CARDS */}
//       <div className="eng-stats">
//         <div className="eng-stat-card">
//           <div className="eng-stat-label">Total engineers</div>
//           <div className="eng-stat-value">{stats.total}</div>
//         </div>
//         <div className="eng-stat-card">
//           <div className="eng-stat-label">Active</div>
//           <div className="eng-stat-value eng-stat-green">{stats.active}</div>
//         </div>
//         <div className="eng-stat-card">
//           <div className="eng-stat-label">Designations</div>
//           <div className="eng-stat-value">{stats.designations}</div>
//         </div>
//       </div>

//       {/* TABLE */}
//       <div className="eng-table-card">
//         <div className="eng-table-header">
//           <span className="eng-table-title">Team roster</span>
//           <div className="eng-filter-wrapper">
//             <select
//               className="eng-status-filter"
//               value={statusFilter}
//               onChange={(e) => setStatusFilter(e.target.value)}
//             >
//               <option value="ALL">All Status</option>
//               <option value="WORKING">Working</option>
//               <option value="NOT_WORKING_RESIGNED">Resigned</option>
//               <option value="NOT_WORKING_TERMINATED">Terminated</option>
//               <option value="NOT_WORKING_RETIRED">Retired</option>
//             </select>
//             <span className="eng-filter-icon">⌄</span>
//           </div>
//           <div className="eng-table-controls">
//             <input
//               className="eng-search"
//               placeholder="Search by name or email…"
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//             />
//           </div>
//         </div>

//         {loading ? (
//           <div className="eng-empty">Loading engineers…</div>
//         ) : filteredList.length === 0 ? (
//           <div className="eng-empty">No engineers found.</div>
//         ) : (
//           <table className="eng-table">
//             <thead>
//               <tr>
//                 <th>Name</th>
//                 <th>Email</th>
//                 <th>Phone</th>
//                 <th>Designation</th>
//                 <th>Status</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredList.map((eng) => (
//                 <tr key={eng.id}>
//                   <td>
//                     <div className="eng-name-cell">
//                       <div className="eng-avatar">{initials(eng.name)}</div>
//                       <span>{eng.name || "—"}</span>
//                     </div>
//                   </td>
//                   <td className="eng-muted">{eng.email || "—"}</td>
//                   <td>{eng.phoneNumber || "—"}</td>
//                   <td className="eng-muted">{eng.designation || "—"}</td>
//                   <td>
//                     <span className={`eng-badge ${eng.engineerStatus === "WORKING" ? "eng-badge-active" : "eng-badge-inactive"}`}>
//                       {statusLabel(eng.engineerStatus)}
//                     </span>
//                   </td>
//                   <td>
//                     <div className="eng-action-btns">
//                       <button className="eng-btn-ghost eng-btn-sm" onClick={() => openEditDrawer(eng)}>
//                         Edit
//                       </button>
//                       <button className="eng-btn-status eng-btn-sm" onClick={() => openStatusModal(eng)}>
//                         Status
//                       </button>
//                       <button
//                         className="eng-btn-ghost eng-btn-sm"
//                         onClick={() => openCheckSalaryModal(eng)}
//                       >
//                         Check Salary
//                       </button>
//                       <button
//                         className="eng-btn-delete eng-btn-sm"
//                         onClick={() => openHistoryModal(eng)}
//                       >
//                         Payment History
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         )}
//       </div>

//       {/* CHECK SALARY MODAL */}
//       {checkSalaryModal && (
//         <div
//           style={{
//             position: "fixed", inset: 0,
//             background: "rgba(0,0,0,0.45)",
//             display: "flex", alignItems: "center", justifyContent: "center",
//             zIndex: 999,
//           }}
//           onClick={() => setCheckSalaryModal(null)}
//         >
//           <div
//             style={{
//               background: "#fff", borderRadius: "12px",
//               padding: "1.5rem", width: "95%", maxWidth: "460px",
//               boxShadow: "0 4px 24px rgba(0,0,0,0.15)",
//             }}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}>
//               <div>
//                 <h3 style={{ margin: 0 }}>Check Salary</h3>
//                 <p style={{ fontSize: "13px", color: "#666", margin: "2px 0 0" }}>
//                   {checkSalaryModal.name}
//                 </p>
//               </div>
//               <button className="eng-btn-ghost" onClick={() => setCheckSalaryModal(null)}>
//                 ✕
//               </button>
//             </div>

//             <label style={{ fontSize: "13px", color: "#555", display: "block", marginBottom: "4px" }}>
//               Select Month
//             </label>
//             <div style={{ display: "flex", gap: "8px", marginBottom: "1.25rem" }}>
//               <input
//                 type="date"
//                 value={checkSalaryMonth}
//                 onChange={(e) => { setCheckSalaryMonth(e.target.value); setCheckSalaryData(null); }}
//                 className="eng-search"
//                 style={{ flex: 1 }}
//               />
//               <button
//                 className="eng-btn-primary"
//                 onClick={handleCheckSalary}
//                 disabled={checkSalaryLoading}
//               >
//                 {checkSalaryLoading ? "Loading..." : "Check"}
//               </button>
//             </div>

//             {checkSalaryData && (
//               <>
//                 <div style={{
//                   display: "grid", gridTemplateColumns: "1fr 1fr",
//                   gap: "10px", marginBottom: "1rem",
//                 }}>
//                   <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "12px" }}>
//                     <p style={{ fontSize: "11px", color: "#888", margin: "0 0 2px" }}>Days Worked</p>
//                     <p style={{ fontSize: "18px", fontWeight: 500, margin: 0 }}>{checkSalaryData.daysWorked}</p>
//                   </div>
//                   <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "12px" }}>
//                     <p style={{ fontSize: "11px", color: "#888", margin: "0 0 2px" }}>Salary / Day</p>
//                     <p style={{ fontSize: "18px", fontWeight: 500, margin: 0 }}>₹ {checkSalaryData.salaryPerDay}</p>
//                   </div>
//                   <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "12px" }}>
//                     <p style={{ fontSize: "11px", color: "#888", margin: "0 0 2px" }}>Total Payable</p>
//                     <p style={{ fontSize: "18px", fontWeight: 500, margin: 0 }}>₹ {checkSalaryData.totalAmountPayable}</p>
//                   </div>
//                   <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "12px" }}>
//                     <p style={{ fontSize: "11px", color: "#888", margin: "0 0 2px" }}>Amount Paid</p>
//                     <p style={{ fontSize: "18px", fontWeight: 500, color: "#2e7d32", margin: 0 }}>₹ {checkSalaryData.amountPaid}</p>
//                   </div>
//                 </div>

//                 <div style={{
//                   display: "flex", alignItems: "center", justifyContent: "space-between",
//                   background: "#fff3f3", borderRadius: "8px", padding: "12px 16px",
//                   marginBottom: "1rem",
//                 }}>
//                   <div>
//                     <p style={{ fontSize: "11px", color: "#888", margin: "0 0 2px" }}>Pending Amount</p>
//                     <p style={{ fontSize: "18px", fontWeight: 500, color: "#e53935", margin: 0 }}>
//                       ₹ {checkSalaryData.pendingAmount}
//                     </p>
//                   </div>
//                   <span className={`eng-badge ${checkSalaryData.paymentStatus === "PAID" ? "eng-badge-active" : "eng-badge-inactive"}`}>
//                     {formatStatus(checkSalaryData.paymentStatus)}
//                   </span>
//                 </div>

//                 {checkSalaryData.remarks && (
//                   <p style={{ fontSize: "13px", color: "#666", margin: 0 }}>
//                     <strong>Remarks:</strong> {checkSalaryData.remarks}
//                   </p>
//                 )}
//               </>
//             )}

//             <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "1rem" }}>
//               <button className="eng-btn-ghost" onClick={() => setCheckSalaryModal(null)}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* PAYMENT HISTORY MODAL */}
//       {historyModal && (
//         <div
//           style={{
//             position: "fixed", inset: 0,
//             background: "rgba(0,0,0,0.45)",
//             display: "flex", alignItems: "center", justifyContent: "center",
//             zIndex: 999,
//           }}
//           onClick={() => setHistoryModal(null)}
//         >
//           <div
//             style={{
//               background: "#fff", borderRadius: "12px",
//               padding: "1.5rem", width: "95%", maxWidth: "900px",
//               maxHeight: "80vh", overflowY: "auto",
//               boxShadow: "0 4px 24px rgba(0,0,0,0.15)",
//             }}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}>
//               <div>
//                 <h3 style={{ margin: 0 }}>Payment History</h3>
//                 <p style={{ fontSize: "13px", color: "#666", margin: "2px 0 0" }}>{historyModal.name}</p>
//               </div>
//               <button className="eng-btn-ghost" onClick={() => setHistoryModal(null)}>✕ Close</button>
//             </div>

//             {historyLoading && (
//               <div style={{ textAlign: "center", padding: "2rem", color: "#888" }}>Loading payment history...</div>
//             )}

//             {!historyLoading && historyData.length === 0 && (
//               <div style={{ textAlign: "center", padding: "2rem", color: "#888" }}>No payment records found.</div>
//             )}

//             {!historyLoading && historyData.length > 0 && (
//               <>
//                 {/* Summary cards */}
//                 <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "10px", marginBottom: "1rem" }}>
//                   <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "12px" }}>
//                     <p style={{ fontSize: "11px", color: "#888", margin: "0 0 2px" }}>Total Payable</p>
//                     <p style={{ fontSize: "15px", fontWeight: 500, margin: 0 }}>
//                       ₹ {historyData.reduce((sum, h) => sum + (h.totalAmountPayable || 0), 0).toLocaleString()}
//                     </p>
//                   </div>
//                   <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "12px" }}>
//                     <p style={{ fontSize: "11px", color: "#888", margin: "0 0 2px" }}>Total Paid</p>
//                     <p style={{ fontSize: "15px", fontWeight: 500, color: "#2e7d32", margin: 0 }}>
//                       ₹ {historyData.reduce((sum, h) => sum + (h.amountPaid || 0), 0).toLocaleString()}
//                     </p>
//                   </div>
//                   <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "12px" }}>
//                     <p style={{ fontSize: "11px", color: "#888", margin: "0 0 2px" }}>Total Pending</p>
//                     <p style={{ fontSize: "15px", fontWeight: 500, color: "#e53935", margin: 0 }}>
//                       ₹ {historyData.reduce((sum, h) => sum + (h.pendingAmount || 0), 0).toLocaleString()}
//                     </p>
//                   </div>
//                 </div>

//                 {/* History Table — now with Salary Slip column */}
//                 <table className="eng-table">
//                   <thead>
//                     <tr>
//                       <th>Month</th>
//                       <th>Days Worked</th>
//                       <th>Salary/Day</th>
//                       <th>Payable</th>
//                       <th>Paid</th>
//                       <th>Pending</th>
//                       <th>Status</th>
//                       <th>Remarks</th>
//                       <th>Salary Slip</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {historyData.map((h) => (
//                       <tr key={h.paymentId}>
//                         <td>{h.paymentMonth}</td>
//                         <td>{h.daysWorked}</td>
//                         <td>₹ {h.salaryPerDay}</td>
//                         <td>₹ {h.totalAmountPayable}</td>
//                         <td>₹ {h.amountPaid}</td>
//                         <td>₹ {h.pendingAmount}</td>
//                         <td>
//                           <span className={`eng-badge ${h.paymentStatus === "PAID" ? "eng-badge-active" : "eng-badge-inactive"}`}>
//                             {formatStatus(h.paymentStatus)}
//                           </span>
//                         </td>
//                         <td style={{ fontSize: "12px", color: "#666" }}>{h.remarks || "—"}</td>
//                         <td>
//                           {/* ── Download Salary Slip Button ── */}
//                           <button
//                             className="eng-btn-ghost eng-btn-sm"
//                             title={`Download salary slip for ${h.paymentMonth}`}
//                             onClick={() => downloadSalarySlip(historyModal, h)}
//                             style={{
//                               display: "inline-flex",
//                               alignItems: "center",
//                               gap: "4px",
//                               whiteSpace: "nowrap",
//                             }}
//                           >
//                             ⬇ Slip
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </>
//             )}
//           </div>
//         </div>
//       )}

//       {/* DELETE CONFIRM MODAL */}
//       {deleteModal && (
//         <div className="eng-modal-overlay" onClick={() => setDeleteModal(null)}>
//           <div className="eng-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="eng-modal-header">
//               <h3 className="eng-modal-title">Delete Engineer</h3>
//               <button className="eng-close-btn" onClick={() => setDeleteModal(null)}>✕</button>
//             </div>
//             <p className="eng-modal-name" style={{ marginBottom: 8 }}>
//               Are you sure you want to delete <strong>{deleteModal.name}</strong>?
//             </p>
//             <p style={{ fontSize: 13, color: "var(--eng-muted, #6b7280)", marginBottom: 20 }}>
//               This action cannot be undone.
//             </p>
//             <div className="eng-modal-actions">
//               <button
//                 className="eng-btn-delete-confirm"
//                 style={{ flex: 1 }}
//                 onClick={handleDeleteEngineer}
//                 disabled={deleteSubmitting}
//               >
//                 {deleteSubmitting ? "Deleting…" : "Yes, Delete"}
//               </button>
//               <button className="eng-btn-ghost" onClick={() => setDeleteModal(null)}>Cancel</button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* STATUS MODAL */}
//       {statusModal && (
//         <div className="eng-modal-overlay" onClick={() => setStatusModal(null)}>
//           <div className="eng-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="eng-modal-header">
//               <h3 className="eng-modal-title">Update Status</h3>
//               <button className="eng-close-btn" onClick={() => setStatusModal(null)}>✕</button>
//             </div>
//             <p className="eng-modal-name">{statusModal.name}</p>
//             <div className="eng-status-options">
//               {[
//                 { value: "WORKING", label: "Working" },
//                 { value: "NOT_WORKING_RESIGNED", label: "Resigned" },
//                 { value: "NOT_WORKING_TERMINATED", label: "Terminated" },
//                 { value: "NOT_WORKING_RETIRED", label: "Retired" },
//               ].map((opt) => (
//                 <label key={opt.value} className={`eng-status-option ${selectedStatus === opt.value ? "selected" : ""}`}>
//                   <input
//                     type="radio"
//                     name="statusPick"
//                     value={opt.value}
//                     checked={selectedStatus === opt.value}
//                     onChange={() => setSelectedStatus(opt.value)}
//                   />
//                   <span className={`eng-badge ${opt.value === "WORKING" ? "eng-badge-active" : "eng-badge-inactive"}`}>
//                     {opt.label}
//                   </span>
//                 </label>
//               ))}
//             </div>
//             <div className="eng-modal-actions">
//               <button
//                 className="eng-btn-primary"
//                 style={{ flex: 1 }}
//                 onClick={handleStatusUpdate}
//                 disabled={statusSubmitting}
//               >
//                 {statusSubmitting ? "Saving…" : "Update Status"}
//               </button>
//               <button className="eng-btn-ghost" onClick={() => setStatusModal(null)}>Cancel</button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* DRAWER */}
//       {drawerOpen && (
//         <div className="eng-overlay" onClick={resetForm}>
//           <div className="eng-drawer" onClick={(e) => e.stopPropagation()}>
//             <div className="eng-drawer-header">
//               <h3 className="eng-drawer-title">
//                 {editEngineerId ? "Update engineer" : "Register engineer"}
//               </h3>
//               <button className="eng-close-btn" onClick={resetForm}>✕</button>
//             </div>

//             <form onSubmit={editEngineerId ? handleEditEngineerRegistration : handleAddEngineer}>
//               <div className="eng-section-label">Basic information</div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Full name *</label>
//                   <input name="name" value={formData.name} onChange={handleChange} placeholder="Rahul Sharma" required />
//                 </div>
//                 <div className="eng-form-group">
//                   <label>Email *</label>
//                   <input name="email" type="email" value={formData.email} onChange={handleChange} placeholder="rahul@company.com" required />
//                 </div>
//               </div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Phone *</label>
//                   <input name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} placeholder="+91 98765 43210" required />
//                 </div>
//                 {!editEngineerId && (
//                   <div className="eng-form-group">
//                     <label>Password *</label>
//                     <input name="password" type="password" value={formData.password} onChange={handleChange} placeholder="••••••••" required />
//                   </div>
//                 )}
//               </div>

//               <div className="eng-section-label">Personal details</div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Blood group</label>
//                   <input name="bloodGroup" value={formData.bloodGroup} onChange={handleChange} placeholder="B+" />
//                 </div>
//                 <div className="eng-form-group">
//                   <label>Emergency contact</label>
//                   <input name="emergencyContact" value={formData.emergencyContact} onChange={handleChange} placeholder="+91 ..." />
//                 </div>
//               </div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>PAN number</label>
//                   <input name="panNumber" value={formData.panNumber} onChange={handleChange} placeholder="ABCDE1234F" />
//                 </div>
//                 <div className="eng-form-group">
//                   <label>Aadhar number</label>
//                   <input name="aadharNumber" value={formData.aadharNumber} onChange={handleChange} placeholder="1234 5678 9012" />
//                 </div>
//               </div>
//               <div className="eng-form-group">
//                 <label>Address</label>
//                 <input name="address" value={formData.address} onChange={handleChange} placeholder="123, Main Street, Nagpur" />
//               </div>

//               <div className="eng-section-label">Employment</div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Designation</label>
//                   <input name="designation" value={formData.designation} onChange={handleChange} placeholder="Site Engineer" />
//                 </div>
//                 <div className="eng-form-group">
//                   <label>Salary / month (₹)</label>
//                   <input name="salaryPerMonth" type="number" value={formData.salaryPerMonth} onChange={handleChange} placeholder="35000" />
//                 </div>
//               </div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Date of birth</label>
//                   <input name="dateOfBirth" type="date" value={formData.dateOfBirth} onChange={handleChange} />
//                 </div>
//               </div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Date of joining</label>
//                   <input name="dateOfJoining" type="date" value={formData.dateOfJoining} onChange={handleChange} />
//                 </div>
//                 <div className="eng-form-group">
//                   <label>Last working date</label>
//                   <input name="lastWorkingDate" type="date" value={formData.lastWorkingDate} onChange={handleChange} />
//                 </div>
//               </div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Status</label>
//                   <select name="engineerStatus" value={formData.engineerStatus} onChange={handleChange}>
//                     <option value="WORKING">Working</option>
//                     <option value="NOT_WORKING_RESIGNED">Resigned</option>
//                     <option value="NOT_WORKING_TERMINATED">Terminated</option>
//                     <option value="NOT_WORKING_RETIRED">Retired</option>
//                   </select>
//                 </div>
//               </div>

//               <div className="eng-section-label">Documents</div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Aadhar card</label>
//                   <label className="eng-file-upload">
//                     <span>{aadharFile ? aadharFile.name : "Choose file"}</span>
//                     <input type="file" style={{ display: "none" }} onChange={(e) => setAadharFile(e.target.files[0])} />
//                   </label>
//                 </div>
//                 <div className="eng-form-group">
//                   <label>Resume</label>
//                   <label className="eng-file-upload">
//                     <span>{resumeFile ? resumeFile.name : "Choose file"}</span>
//                     <input type="file" style={{ display: "none" }} onChange={(e) => setResumeFile(e.target.files[0])} />
//                   </label>
//                 </div>
//               </div>

//               <div className="eng-form-actions">
//                 <button type="submit" className="eng-btn-primary" style={{ flex: 1 }} disabled={submitting}>
//                   {submitting ? "Saving…" : editEngineerId ? "Save changes" : "Register engineer"}
//                 </button>
//                 <button type="button" className="eng-btn-ghost" onClick={resetForm}>Cancel</button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default Engineer;





// import React, { useEffect, useState } from "react";
// import axiosInstance from "../../utils/axiosInstance";
// import { BASE_URL } from "../../config";
// import "./Engineer.css";

// // ─── Salary Slip Generator ────────────────────────────────────────────────────
// function generateSalarySlipHTML(eng, h) {
//   const month = h.paymentMonth || "—";
//   const today = new Date().toLocaleDateString("en-IN", { day: "2-digit", month: "long", year: "numeric" });

//   return `<!DOCTYPE html>
// <html lang="en">
// <head>
// <meta charset="UTF-8"/>
// <title>Salary Slip – ${eng.name} – ${month}</title>
// <style>
//   @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display&family=DM+Sans:wght@400;500;600&display=swap');
//   *{box-sizing:border-box;margin:0;padding:0}
//   body{font-family:'DM Sans',sans-serif;background:#f4f4f0;display:flex;justify-content:center;padding:40px 16px}
//   .slip{background:#fff;width:720px;border-radius:4px;overflow:hidden;box-shadow:0 2px 16px rgba(0,0,0,.10)}
//   .header{background:#1a1a2e;color:#fff;padding:32px 40px;display:flex;justify-content:space-between;align-items:flex-start}
//   .company{font-family:'DM Serif Display',serif;font-size:22px;letter-spacing:.5px;margin-bottom:4px}
//   .header-sub{font-size:12px;opacity:.6;line-height:1.6}
//   .slip-label{text-align:right}
//   .slip-label .title{font-size:13px;letter-spacing:2px;text-transform:uppercase;opacity:.6;margin-bottom:6px}
//   .slip-label .month{font-family:'DM Serif Display',serif;font-size:20px}
//   .divider-bar{height:4px;background:linear-gradient(90deg,#e8b86d 0%,#c97d4e 100%)}
//   .body{padding:32px 40px}
//   .emp-section{display:grid;grid-template-columns:1fr 1fr;gap:16px 32px;margin-bottom:28px;padding-bottom:24px;border-bottom:1px solid #ebebeb}
//   .field label{font-size:10px;text-transform:uppercase;letter-spacing:1.5px;color:#999;display:block;margin-bottom:3px}
//   .field span{font-size:14px;color:#1a1a2e;font-weight:500}
//   .earnings-table{width:100%;border-collapse:collapse;margin-bottom:24px}
//   .earnings-table th{font-size:10px;text-transform:uppercase;letter-spacing:1.5px;color:#999;text-align:left;padding:8px 12px;background:#f9f9f7;border-bottom:2px solid #ebebeb}
//   .earnings-table td{padding:10px 12px;font-size:13px;color:#333;border-bottom:1px solid #f0f0f0}
//   .earnings-table tr:last-child td{border-bottom:none}
//   .earnings-table .amount{text-align:right;font-weight:500}
//   .total-row{background:#1a1a2e!important}
//   .total-row td{color:#fff!important;font-weight:600!important;font-size:14px!important;padding:14px 12px!important;border:none!important}
//   .status-section{display:flex;justify-content:space-between;align-items:center;background:#f9f9f7;border-radius:4px;padding:16px 20px;margin-bottom:24px}
//   .status-section .label{font-size:11px;text-transform:uppercase;letter-spacing:1.5px;color:#999;margin-bottom:4px}
//   .status-section .value{font-size:15px;font-weight:600;color:#1a1a2e}
//   .badge{display:inline-block;padding:4px 12px;border-radius:20px;font-size:11px;font-weight:600;letter-spacing:.5px;text-transform:uppercase}
//   .badge-paid{background:#e6f4ea;color:#2e7d32}
//   .badge-pending{background:#fff3f3;color:#e53935}
//   .remarks-box{background:#fffbf0;border-left:3px solid #e8b86d;padding:12px 16px;font-size:13px;color:#666;margin-bottom:24px;border-radius:0 4px 4px 0}
//   .footer{border-top:1px solid #ebebeb;padding:20px 40px;display:flex;justify-content:space-between;font-size:11px;color:#bbb;background:#fafafa}
//   .sig{text-align:right}
//   .sig-line{width:140px;border-top:1px solid #ccc;margin:28px 0 4px auto}
//   .sig-label{font-size:10px;text-transform:uppercase;letter-spacing:1px;color:#999}
//   @media print{body{background:#fff;padding:0}button{display:none!important}.slip{box-shadow:none}}
// </style>
// </head>
// <body>
// <div class="slip">
//   <div class="header">
//     <div>
//       <div class="company">Nagpur Properties</div>
//       <div class="header-sub">Nagpur, Maharashtra, India<br/></div>
//     </div>
//     <div class="slip-label">
//       <div class="title">Salary Slip</div>
//       <div class="month">${month}</div>
//     </div>
//   </div>
//   <div class="divider-bar"></div>
//   <div class="body">
//     <!-- Employee Info -->
//     <div class="emp-section">
//       <div class="field"><label>Employee Name</label><span>${eng.name || "—"}</span></div>
//       <div class="field"><label>Designation</label><span>${eng.designation || "—"}</span></div>
//       <div class="field"><label>Email</label><span>${eng.email || "—"}</span></div>
//       <div class="field"><label>Phone</label><span>${eng.phoneNumber || "—"}</span></div>
//       <div class="field"><label>Payment Month</label><span>${month}</span></div>
//       <div class="field"><label>Generated On</label><span>${today}</span></div>
//     </div>

//     <!-- Earnings Table -->
//     <table class="earnings-table">
//       <thead>
//         <tr>
//           <th>Component</th>
//           <th>Details</th>
//           <th class="amount">Amount (₹)</th>
//         </tr>
//       </thead>
//       <tbody>
//         <tr>
//           <td>Basic Salary (Monthly)</td>
//           <td>${h.daysWorked} days × ₹${h.salaryPerDay}/day</td>
//           <td class="amount">₹ ${(h.totalAmountPayable || 0).toLocaleString("en-IN")}</td>
//         </tr>
//         <tr>
//           <td>Amount Paid</td>
//           <td>Disbursed</td>
//           <td class="amount" style="color:#2e7d32">₹ ${(h.amountPaid || 0).toLocaleString("en-IN")}</td>
//         </tr>
//         <tr>
//           <td>Pending Amount</td>
//           <td>Balance due</td>
//           <td class="amount" style="color:#e53935">₹ ${(h.pendingAmount || 0).toLocaleString("en-IN")}</td>
//         </tr>
//         <tr class="total-row">
//           <td colspan="2">Net Payable</td>
//           <td class="amount">₹ ${(h.totalAmountPayable || 0).toLocaleString("en-IN")}</td>
//         </tr>
//       </tbody>
//     </table>

//     <!-- Status -->
//     <div class="status-section">
//       <div>
//         <div class="label">Payment Status</div>
//         <div class="value">${h.paymentStatus === "PAID" ? "Fully Paid" : "Pending / Partial"}</div>
//       </div>
//       <span class="badge ${h.paymentStatus === "PAID" ? "badge-paid" : "badge-pending"}">
//         ${(h.paymentStatus || "").replace(/_/g, " ")}
//       </span>
//     </div>

//     ${h.remarks ? `<div class="remarks-box"><strong>Remarks:</strong> ${h.remarks}</div>` : ""}

//     <!-- Signature -->
//     <div class="sig">
//       <div class="sig-line"></div>
//       <div class="sig-label">Authorised Signatory</div>
//     </div>
//   </div>
//   <div class="footer">
//     <span>This is a computer-generated salary slip and does not require a physical signature.</span>
//     <span>Nagpur Properties © ${new Date().getFullYear()}</span>
//   </div>
// </div>
// </body>
// </html>`;
// }

// function downloadSalarySlip(eng, h) {
//   const html = generateSalarySlipHTML(eng, h);
//   const blob = new Blob([html], { type: "text/html" });
//   const url = URL.createObjectURL(blob);
//   const a = document.createElement("a");
//   a.href = url;
//   a.download = `SalarySlip_${(eng.name || "Engineer").replace(/\s+/g, "_")}_${h.paymentMonth || "unknown"}.html`;
//   document.body.appendChild(a);
//   a.click();
//   document.body.removeChild(a);
//   URL.revokeObjectURL(url);
// }
// // ─────────────────────────────────────────────────────────────────────────────

// function Engineer() {
//   const token = JSON.parse(localStorage.getItem("NagpurProperties"))?.token;

//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [editEngineerId, setEditEngineerId] = useState(null);
//   const [engineerList, setEngineerList] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [submitting, setSubmitting] = useState(false);

//   const [statusFilter, setStatusFilter] = useState("ALL");
//   const [statusModal, setStatusModal] = useState(null);
//   const [selectedStatus, setSelectedStatus] = useState("WORKING");
//   const [statusSubmitting, setStatusSubmitting] = useState(false);
//   const [deleteModal, setDeleteModal] = useState(null);
//   const [deleteSubmitting, setDeleteSubmitting] = useState(false);

//   // ── Payment History Modal ──
//   const [historyModal, setHistoryModal] = useState(null);
//   const [historyData, setHistoryData] = useState([]);
//   const [historyLoading, setHistoryLoading] = useState(false);

//   // ── Check Salary Modal ──
//   const [checkSalaryModal, setCheckSalaryModal] = useState(null);
//   const [checkSalaryMonth, setCheckSalaryMonth] = useState("");
//   const [checkSalaryData, setCheckSalaryData] = useState(null);
//   const [checkSalaryLoading, setCheckSalaryLoading] = useState(false);

//   const emptyForm = {
//     name: "",
//     email: "",
//     phoneNumber: "",
//     password: "",
//     bloodGroup: "",
//     panNumber: "",
//     aadharNumber: "",
//     emergencyContact: "",
//     designation: "",
//     salaryPerMonth: "",
//     welfareAmount: "",       // ← NEW
//     address: "",
//     dateOfJoining: "",
//     dateOfBirth: "",
//     lastWorkingDate: "",
//     engineerStatus: "WORKING",
//   };

//   const [formData, setFormData] = useState(emptyForm);

//   const [aadharFile, setAadharFile] = useState(null);
//   const [resumeFile, setResumeFile] = useState(null);

//   // ─── HELPERS ─────────────────────────────────
//   const initials = (name = "") =>
//     name.trim().split(" ").slice(0, 2).map((w) => w[0]?.toUpperCase() || "").join("");

//   const filteredList = engineerList.filter((e) => {
//     const matchesSearch =
//       (e.name || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
//       (e.email || "").toLowerCase().includes(searchQuery.toLowerCase());
//     const matchesStatus =
//       statusFilter === "ALL" || e.engineerStatus === statusFilter;
//     return matchesSearch && matchesStatus;
//   });

//   const stats = {
//     total: engineerList.length,
//     active: engineerList.filter((e) => e.engineerStatus === "WORKING").length,
//     designations: new Set(engineerList.map((e) => e.designation).filter(Boolean)).size,
//   };

//   const statusLabel = (status) => {
//     if (!status || status === "WORKING") return "Working";
//     return status.replace("NOT_WORKING_", "").replace(/_/g, " ");
//   };

//   const formatStatus = (status) => status ? status.replace(/_/g, " ") : "-";

//   // ─── FORM HANDLERS ───────────────────────────
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const resetForm = () => {
//     setFormData(emptyForm);
//     setAadharFile(null);
//     setResumeFile(null);
//     setEditEngineerId(null);
//     setDrawerOpen(false);
//   };

//   useEffect(() => {
//     if (formData.lastWorkingDate) {
//       setFormData((prev) => ({ ...prev, engineerStatus: "NOT_WORKING_RESIGNED" }));
//     }
//   }, [formData.lastWorkingDate]);

//   const buildRegisterFormData = () => {
//     const data = new FormData();
//     const dto = {};
//     Object.keys(formData).forEach((key) => {
//       if (formData[key] !== "" && formData[key] !== null && formData[key] !== undefined)
//         dto[key] = formData[key];
//     });
//     data.append("engineerDto", new Blob([JSON.stringify(dto)], { type: "application/json" }));
//     if (aadharFile) data.append("aadharCardImg", aadharFile);
//     if (resumeFile) data.append("resume", resumeFile);
//     return data;
//   };

//   const buildUpdateFormData = () => {
//     const data = new FormData();
//     const { engineerStatus, ...rest } = formData;
//     const dto = {};
//     Object.keys(rest).forEach((key) => {
//       if (rest[key] !== "" && rest[key] !== null && rest[key] !== undefined)
//         dto[key] = rest[key];
//     });
//     data.append("request", new Blob([JSON.stringify(dto)], { type: "application/json" }));
//     data.append("engineerStatus", new Blob([JSON.stringify(engineerStatus)], { type: "application/json" }));
//     if (aadharFile) data.append("aadharCardImg", aadharFile);
//     if (resumeFile) data.append("resume", resumeFile);
//     return data;
//   };

//   // ─── API CALLS ───────────────────────────────
//   async function getEngineerList() {
//     try {
//       const response = await axiosInstance.get(`${BASE_URL}/allEngineers`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setEngineerList(response.data.sort((a, b) => b.id - a.id));
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   }

//   async function fetchEngineerById(id) {
//     try {
//       const response = await axiosInstance.get(`${BASE_URL}/engineer/${id}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       return response.data;
//     } catch (error) {
//       console.error(error);
//       alert("Failed to fetch engineer details");
//       return null;
//     }
//   }

//   // ── Payment History ───────────────────────────
//   async function openHistoryModal(eng) {
//     setHistoryModal({
//       id: eng.id,
//       name: eng.name,
//       email: eng.email,
//       phoneNumber: eng.phoneNumber,
//       designation: eng.designation,
//     });
//     setHistoryData([]);
//     setHistoryLoading(true);
//     try {
//       const response = await axiosInstance.get(
//         `${BASE_URL}/engineer/${eng.id}/payment/history`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       setHistoryData(response.data);
//     } catch (error) {
//       console.error(error);
//       alert(error?.response?.data?.message || "Failed to fetch payment history");
//       setHistoryModal(null);
//     } finally {
//       setHistoryLoading(false);
//     }
//   }

//   // ── Check Salary ──────────────────────────────
//   function openCheckSalaryModal(eng) {
//     setCheckSalaryModal({ id: eng.id, name: eng.name });
//     setCheckSalaryMonth("");
//     setCheckSalaryData(null);
//   }

//   async function handleCheckSalary() {
//     if (!checkSalaryMonth) { alert("Please select a month"); return; }
//     const formattedMonth = checkSalaryMonth.slice(0, 7) + "-01";
//     setCheckSalaryLoading(true);
//     setCheckSalaryData(null);
//     try {
//       const response = await axiosInstance.post(
//         `${BASE_URL}/engineer/${checkSalaryModal.id}/payment/generate`,
//         null,
//         {
//           params: {
//             engineerId: checkSalaryModal.id,
//             paymentMonth: formattedMonth,
//           },
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       setCheckSalaryData(response.data);
//     } catch (error) {
//       console.error(error);
//       alert(error?.response?.data?.message || "Failed to fetch salary info");
//     } finally {
//       setCheckSalaryLoading(false);
//     }
//   }

//   async function handleAddEngineer(e) {
//     e.preventDefault();
//     setSubmitting(true);
//     try {
//       const response = await axiosInstance.post(
//         `${BASE_URL}/registerEngineer`,
//         buildRegisterFormData(),
//         { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
//       );
//       if (response.status === 200) {
//         alert("Engineer Registered Successfully");
//         resetForm();
//         getEngineerList();
//       }
//     } catch (error) {
//       let message = "Something went wrong";
//       if (error.response) {
//         const { status, data } = error.response;
//         if (status === 409) message = data?.message || "Email already exists";
//         else if (status === 400) message = data?.message || "Invalid data";
//         else if (status === 401) message = "Unauthorized. Please login again.";
//         else if (status === 500) message = data?.message || "Server error. Try again later.";
//         else message = data?.message || `Error: ${status}`;
//       } else if (error.request) {
//         message = "No response from server. Check your connection.";
//       } else {
//         message = error.message;
//       }
//       alert(message);
//     } finally {
//       setSubmitting(false);
//     }
//   }

//   async function handleEditEngineerRegistration(e) {
//     e.preventDefault();
//     setSubmitting(true);
//     try {
//       const response = await axiosInstance.put(
//         `${BASE_URL}/engineer/update/${editEngineerId}`,
//         buildUpdateFormData(),
//         { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
//       );
//       if (response.status === 200) {
//         alert("Engineer Updated Successfully");
//         resetForm();
//         getEngineerList();
//       }
//     } catch (error) {
//       alert(error?.response?.data?.message || "Update failed");
//     } finally {
//       setSubmitting(false);
//     }
//   }

//   async function handleDeleteEngineer() {
//     setDeleteSubmitting(true);
//     try {
//       const response = await axiosInstance.delete(
//         `${BASE_URL}/deleteEngineer/${deleteModal.id}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       if (response.status === 200) {
//         alert("Engineer Deleted Successfully");
//         setDeleteModal(null);
//         getEngineerList();
//       }
//     } catch (error) {
//       alert(error?.response?.data?.message || "Delete failed");
//     } finally {
//       setDeleteSubmitting(false);
//     }
//   }

//   function openStatusModal(eng) {
//     setStatusModal({ id: eng.id, name: eng.name });
//     setSelectedStatus(eng.engineerStatus || "WORKING");
//   }

//   async function handleStatusUpdate() {
//     setStatusSubmitting(true);
//     try {
//       const response = await axiosInstance.patch(
//         `${BASE_URL}/engineer/update/${statusModal.id}/status?engineerStatus=${selectedStatus}`,
//         null,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       if (response.status === 200) {
//         alert("Status Updated Successfully");
//         setStatusModal(null);
//         getEngineerList();
//       }
//     } catch (error) {
//       alert(error?.response?.data?.message || "Status update failed");
//     } finally {
//       setStatusSubmitting(false);
//     }
//   }

//   async function openEditDrawer(engineer) {
//     const data = await fetchEngineerById(engineer.id);
//     if (!data) return;
//     setEditEngineerId(data.id);
//     setFormData({
//       name: data.name || "",
//       email: data.email || "",
//       phoneNumber: data.phoneNumber || "",
//       password: "",
//       bloodGroup: data.bloodGroup || "",
//       panNumber: data.panNumber || "",
//       aadharNumber: data.aadharNumber || "",
//       emergencyContact: data.emergencyContact || "",
//       designation: data.designation || "",
//       salaryPerMonth: data.salaryPerMonth != null ? String(data.salaryPerMonth) : "",
//       welfareAmount: data.welfareAmount != null ? String(data.welfareAmount) : "",  // ← NEW
//       address: data.address || "",
//       dateOfJoining: data.dateOfJoining || "",
//       dateOfBirth: data.dateOfBirth || "",
//       lastWorkingDate: data.lastWorkingDate || "",
//       engineerStatus: data.engineerStatus || "WORKING",
//     });
//     setDrawerOpen(true);
//   }

//   useEffect(() => { getEngineerList(); }, []);

//   // ─── RENDER ──────────────────────────────────
//   return (
//     <div className="eng-page">

//       {/* TOP BAR */}
//       <div className="eng-topbar">
//         <div>
//           <h2 className="eng-page-title">Engineers</h2>
//           <p className="eng-page-sub">Manage your engineering team</p>
//         </div>
//         <button className="eng-btn-primary" onClick={() => { resetForm(); setDrawerOpen(true); }}>
//           + Add engineer
//         </button>
//       </div>

//       {/* STAT CARDS */}
//       <div className="eng-stats">
//         <div className="eng-stat-card">
//           <div className="eng-stat-label">Total engineers</div>
//           <div className="eng-stat-value">{stats.total}</div>
//         </div>
//         <div className="eng-stat-card">
//           <div className="eng-stat-label">Active</div>
//           <div className="eng-stat-value eng-stat-green">{stats.active}</div>
//         </div>
//         <div className="eng-stat-card">
//           <div className="eng-stat-label">Designations</div>
//           <div className="eng-stat-value">{stats.designations}</div>
//         </div>
//       </div>

//       {/* TABLE */}
//       <div className="eng-table-card">
//         <div className="eng-table-header">
//           <span className="eng-table-title">Team roster</span>
//           <div className="eng-filter-wrapper">
//             <select
//               className="eng-status-filter"
//               value={statusFilter}
//               onChange={(e) => setStatusFilter(e.target.value)}
//             >
//               <option value="ALL">All Status</option>
//               <option value="WORKING">Working</option>
//               <option value="NOT_WORKING_RESIGNED">Resigned</option>
//               <option value="NOT_WORKING_TERMINATED">Terminated</option>
//               <option value="NOT_WORKING_RETIRED">Retired</option>
//             </select>
//             <span className="eng-filter-icon">⌄</span>
//           </div>
//           <div className="eng-table-controls">
//             <input
//               className="eng-search"
//               placeholder="Search by name or email…"
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//             />
//           </div>
//         </div>

//         {loading ? (
//           <div className="eng-empty">Loading engineers…</div>
//         ) : filteredList.length === 0 ? (
//           <div className="eng-empty">No engineers found.</div>
//         ) : (
//           <table className="eng-table">
//             <thead>
//               <tr>
//                 <th>Name</th>
//                 <th>Email</th>
//                 <th>Phone</th>
//                 <th>Designation</th>
//                 <th>Status</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredList.map((eng) => (
//                 <tr key={eng.id}>
//                   <td>
//                     <div className="eng-name-cell">
//                       <div className="eng-avatar">{initials(eng.name)}</div>
//                       <span>{eng.name || "—"}</span>
//                     </div>
//                   </td>
//                   <td className="eng-muted">{eng.email || "—"}</td>
//                   <td>{eng.phoneNumber || "—"}</td>
//                   <td className="eng-muted">{eng.designation || "—"}</td>
//                   <td>
//                     <span className={`eng-badge ${eng.engineerStatus === "WORKING" ? "eng-badge-active" : "eng-badge-inactive"}`}>
//                       {statusLabel(eng.engineerStatus)}
//                     </span>
//                   </td>
//                   <td>
//                     <div className="eng-action-btns">
//                       <button className="eng-btn-ghost eng-btn-sm" onClick={() => openEditDrawer(eng)}>
//                         Edit
//                       </button>
//                       <button className="eng-btn-status eng-btn-sm" onClick={() => openStatusModal(eng)}>
//                         Status
//                       </button>
//                       <button
//                         className="eng-btn-ghost eng-btn-sm"
//                         onClick={() => openCheckSalaryModal(eng)}
//                       >
//                         Check Salary
//                       </button>
//                       <button
//                         className="eng-btn-delete eng-btn-sm"
//                         onClick={() => openHistoryModal(eng)}
//                       >
//                         Payment History
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         )}
//       </div>

//       {/* CHECK SALARY MODAL */}
//       {checkSalaryModal && (
//         <div
//           style={{
//             position: "fixed", inset: 0,
//             background: "rgba(0,0,0,0.45)",
//             display: "flex", alignItems: "center", justifyContent: "center",
//             zIndex: 999,
//           }}
//           onClick={() => setCheckSalaryModal(null)}
//         >
//           <div
//             style={{
//               background: "#fff", borderRadius: "12px",
//               padding: "1.5rem", width: "95%", maxWidth: "460px",
//               boxShadow: "0 4px 24px rgba(0,0,0,0.15)",
//             }}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}>
//               <div>
//                 <h3 style={{ margin: 0 }}>Check Salary</h3>
//                 <p style={{ fontSize: "13px", color: "#666", margin: "2px 0 0" }}>
//                   {checkSalaryModal.name}
//                 </p>
//               </div>
//               <button className="eng-btn-ghost" onClick={() => setCheckSalaryModal(null)}>
//                 ✕
//               </button>
//             </div>

//             <label style={{ fontSize: "13px", color: "#555", display: "block", marginBottom: "4px" }}>
//               Select Month
//             </label>
//             <div style={{ display: "flex", gap: "8px", marginBottom: "1.25rem" }}>
//               <input
//                 type="date"
//                 value={checkSalaryMonth}
//                 onChange={(e) => { setCheckSalaryMonth(e.target.value); setCheckSalaryData(null); }}
//                 className="eng-search"
//                 style={{ flex: 1 }}
//               />
//               <button
//                 className="eng-btn-primary"
//                 onClick={handleCheckSalary}
//                 disabled={checkSalaryLoading}
//               >
//                 {checkSalaryLoading ? "Loading..." : "Check"}
//               </button>
//             </div>

//             {checkSalaryData && (
//               <>
//                 <div style={{
//                   display: "grid", gridTemplateColumns: "1fr 1fr",
//                   gap: "10px", marginBottom: "1rem",
//                 }}>
//                   <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "12px" }}>
//                     <p style={{ fontSize: "11px", color: "#888", margin: "0 0 2px" }}>Days Worked</p>
//                     <p style={{ fontSize: "18px", fontWeight: 500, margin: 0 }}>{checkSalaryData.daysWorked}</p>
//                   </div>
//                   <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "12px" }}>
//                     <p style={{ fontSize: "11px", color: "#888", margin: "0 0 2px" }}>Salary / Day</p>
//                     <p style={{ fontSize: "18px", fontWeight: 500, margin: 0 }}>₹ {checkSalaryData.salaryPerDay}</p>
//                   </div>
//                   <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "12px" }}>
//                     <p style={{ fontSize: "11px", color: "#888", margin: "0 0 2px" }}>Total Payable</p>
//                     <p style={{ fontSize: "18px", fontWeight: 500, margin: 0 }}>₹ {checkSalaryData.totalAmountPayable}</p>
//                   </div>
//                   <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "12px" }}>
//                     <p style={{ fontSize: "11px", color: "#888", margin: "0 0 2px" }}>Amount Paid</p>
//                     <p style={{ fontSize: "18px", fontWeight: 500, color: "#2e7d32", margin: 0 }}>₹ {checkSalaryData.amountPaid}</p>
//                   </div>
//                 </div>

//                 <div style={{
//                   display: "flex", alignItems: "center", justifyContent: "space-between",
//                   background: "#fff3f3", borderRadius: "8px", padding: "12px 16px",
//                   marginBottom: "1rem",
//                 }}>
//                   <div>
//                     <p style={{ fontSize: "11px", color: "#888", margin: "0 0 2px" }}>Pending Amount</p>
//                     <p style={{ fontSize: "18px", fontWeight: 500, color: "#e53935", margin: 0 }}>
//                       ₹ {checkSalaryData.pendingAmount}
//                     </p>
//                   </div>
//                   <span className={`eng-badge ${checkSalaryData.paymentStatus === "PAID" ? "eng-badge-active" : "eng-badge-inactive"}`}>
//                     {formatStatus(checkSalaryData.paymentStatus)}
//                   </span>
//                 </div>

//                 {checkSalaryData.remarks && (
//                   <p style={{ fontSize: "13px", color: "#666", margin: 0 }}>
//                     <strong>Remarks:</strong> {checkSalaryData.remarks}
//                   </p>
//                 )}
//               </>
//             )}

//             <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "1rem" }}>
//               <button className="eng-btn-ghost" onClick={() => setCheckSalaryModal(null)}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* PAYMENT HISTORY MODAL */}
//       {historyModal && (
//         <div
//           style={{
//             position: "fixed", inset: 0,
//             background: "rgba(0,0,0,0.45)",
//             display: "flex", alignItems: "center", justifyContent: "center",
//             zIndex: 999,
//           }}
//           onClick={() => setHistoryModal(null)}
//         >
//           <div
//             style={{
//               background: "#fff", borderRadius: "12px",
//               padding: "1.5rem", width: "95%", maxWidth: "900px",
//               maxHeight: "80vh", overflowY: "auto",
//               boxShadow: "0 4px 24px rgba(0,0,0,0.15)",
//             }}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}>
//               <div>
//                 <h3 style={{ margin: 0 }}>Payment History</h3>
//                 <p style={{ fontSize: "13px", color: "#666", margin: "2px 0 0" }}>{historyModal.name}</p>
//               </div>
//               <button className="eng-btn-ghost" onClick={() => setHistoryModal(null)}>✕ Close</button>
//             </div>

//             {historyLoading && (
//               <div style={{ textAlign: "center", padding: "2rem", color: "#888" }}>Loading payment history...</div>
//             )}

//             {!historyLoading && historyData.length === 0 && (
//               <div style={{ textAlign: "center", padding: "2rem", color: "#888" }}>No payment records found.</div>
//             )}

//             {!historyLoading && historyData.length > 0 && (
//               <>
//                 <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "10px", marginBottom: "1rem" }}>
//                   <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "12px" }}>
//                     <p style={{ fontSize: "11px", color: "#888", margin: "0 0 2px" }}>Total Payable</p>
//                     <p style={{ fontSize: "15px", fontWeight: 500, margin: 0 }}>
//                       ₹ {historyData.reduce((sum, h) => sum + (h.totalAmountPayable || 0), 0).toLocaleString()}
//                     </p>
//                   </div>
//                   <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "12px" }}>
//                     <p style={{ fontSize: "11px", color: "#888", margin: "0 0 2px" }}>Total Paid</p>
//                     <p style={{ fontSize: "15px", fontWeight: 500, color: "#2e7d32", margin: 0 }}>
//                       ₹ {historyData.reduce((sum, h) => sum + (h.amountPaid || 0), 0).toLocaleString()}
//                     </p>
//                   </div>
//                   <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "12px" }}>
//                     <p style={{ fontSize: "11px", color: "#888", margin: "0 0 2px" }}>Total Pending</p>
//                     <p style={{ fontSize: "15px", fontWeight: 500, color: "#e53935", margin: 0 }}>
//                       ₹ {historyData.reduce((sum, h) => sum + (h.pendingAmount || 0), 0).toLocaleString()}
//                     </p>
//                   </div>
//                 </div>

//                 <table className="eng-table">
//                   <thead>
//                     <tr>
//                       <th>Month</th>
//                       <th>Days Worked</th>
//                       <th>Salary/Day</th>
//                       <th>Payable</th>
//                       <th>Paid</th>
//                       <th>Pending</th>
//                       <th>Status</th>
//                       <th>Remarks</th>
//                       <th>Salary Slip</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {historyData.map((h) => (
//                       <tr key={h.paymentId}>
//                         <td>{h.paymentMonth}</td>
//                         <td>{h.daysWorked}</td>
//                         <td>₹ {h.salaryPerDay}</td>
//                         <td>₹ {h.totalAmountPayable}</td>
//                         <td>₹ {h.amountPaid}</td>
//                         <td>₹ {h.pendingAmount}</td>
//                         <td>
//                           <span className={`eng-badge ${h.paymentStatus === "PAID" ? "eng-badge-active" : "eng-badge-inactive"}`}>
//                             {formatStatus(h.paymentStatus)}
//                           </span>
//                         </td>
//                         <td style={{ fontSize: "12px", color: "#666" }}>{h.remarks || "—"}</td>
//                         <td>
//                           <button
//                             className="eng-btn-ghost eng-btn-sm"
//                             title={`Download salary slip for ${h.paymentMonth}`}
//                             onClick={() => downloadSalarySlip(historyModal, h)}
//                             style={{ display: "inline-flex", alignItems: "center", gap: "4px", whiteSpace: "nowrap" }}
//                           >
//                             ⬇ Slip
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </>
//             )}
//           </div>
//         </div>
//       )}

//       {/* DELETE CONFIRM MODAL */}
//       {deleteModal && (
//         <div className="eng-modal-overlay" onClick={() => setDeleteModal(null)}>
//           <div className="eng-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="eng-modal-header">
//               <h3 className="eng-modal-title">Delete Engineer</h3>
//               <button className="eng-close-btn" onClick={() => setDeleteModal(null)}>✕</button>
//             </div>
//             <p className="eng-modal-name" style={{ marginBottom: 8 }}>
//               Are you sure you want to delete <strong>{deleteModal.name}</strong>?
//             </p>
//             <p style={{ fontSize: 13, color: "var(--eng-muted, #6b7280)", marginBottom: 20 }}>
//               This action cannot be undone.
//             </p>
//             <div className="eng-modal-actions">
//               <button
//                 className="eng-btn-delete-confirm"
//                 style={{ flex: 1 }}
//                 onClick={handleDeleteEngineer}
//                 disabled={deleteSubmitting}
//               >
//                 {deleteSubmitting ? "Deleting…" : "Yes, Delete"}
//               </button>
//               <button className="eng-btn-ghost" onClick={() => setDeleteModal(null)}>Cancel</button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* STATUS MODAL */}
//       {statusModal && (
//         <div className="eng-modal-overlay" onClick={() => setStatusModal(null)}>
//           <div className="eng-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="eng-modal-header">
//               <h3 className="eng-modal-title">Update Status</h3>
//               <button className="eng-close-btn" onClick={() => setStatusModal(null)}>✕</button>
//             </div>
//             <p className="eng-modal-name">{statusModal.name}</p>
//             <div className="eng-status-options">
//               {[
//                 { value: "WORKING", label: "Working" },
//                 { value: "NOT_WORKING_RESIGNED", label: "Resigned" },
//                 { value: "NOT_WORKING_TERMINATED", label: "Terminated" },
//                 { value: "NOT_WORKING_RETIRED", label: "Retired" },
//               ].map((opt) => (
//                 <label key={opt.value} className={`eng-status-option ${selectedStatus === opt.value ? "selected" : ""}`}>
//                   <input
//                     type="radio"
//                     name="statusPick"
//                     value={opt.value}
//                     checked={selectedStatus === opt.value}
//                     onChange={() => setSelectedStatus(opt.value)}
//                   />
//                   <span className={`eng-badge ${opt.value === "WORKING" ? "eng-badge-active" : "eng-badge-inactive"}`}>
//                     {opt.label}
//                   </span>
//                 </label>
//               ))}
//             </div>
//             <div className="eng-modal-actions">
//               <button
//                 className="eng-btn-primary"
//                 style={{ flex: 1 }}
//                 onClick={handleStatusUpdate}
//                 disabled={statusSubmitting}
//               >
//                 {statusSubmitting ? "Saving…" : "Update Status"}
//               </button>
//               <button className="eng-btn-ghost" onClick={() => setStatusModal(null)}>Cancel</button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* DRAWER */}
//       {drawerOpen && (
//         <div className="eng-overlay" onClick={resetForm}>
//           <div className="eng-drawer" onClick={(e) => e.stopPropagation()}>
//             <div className="eng-drawer-header">
//               <h3 className="eng-drawer-title">
//                 {editEngineerId ? "Update engineer" : "Register engineer"}
//               </h3>
//               <button className="eng-close-btn" onClick={resetForm}>✕</button>
//             </div>

//             <form onSubmit={editEngineerId ? handleEditEngineerRegistration : handleAddEngineer}>
//               <div className="eng-section-label">Basic information</div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Full name *</label>
//                   <input name="name" value={formData.name} onChange={handleChange} placeholder="Rahul Sharma" required />
//                 </div>
//                 <div className="eng-form-group">
//                   <label>Email *</label>
//                   <input name="email" type="email" value={formData.email} onChange={handleChange} placeholder="rahul@company.com" required />
//                 </div>
//               </div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Phone *</label>
//                   <input name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} placeholder="+91 98765 43210" required />
//                 </div>
//                 {!editEngineerId && (
//                   <div className="eng-form-group">
//                     <label>Password *</label>
//                     <input name="password" type="password" value={formData.password} onChange={handleChange} placeholder="••••••••" required />
//                   </div>
//                 )}
//               </div>

//               <div className="eng-section-label">Personal details</div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Blood group</label>
//                   <input name="bloodGroup" value={formData.bloodGroup} onChange={handleChange} placeholder="B+" />
//                 </div>
//                 <div className="eng-form-group">
//                   <label>Emergency contact</label>
//                   <input name="emergencyContact" value={formData.emergencyContact} onChange={handleChange} placeholder="+91 ..." />
//                 </div>
//               </div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>PAN number</label>
//                   <input name="panNumber" value={formData.panNumber} onChange={handleChange} placeholder="ABCDE1234F" />
//                 </div>
//                 <div className="eng-form-group">
//                   <label>Aadhar number</label>
//                   <input name="aadharNumber" value={formData.aadharNumber} onChange={handleChange} placeholder="1234 5678 9012" />
//                 </div>
//               </div>
//               <div className="eng-form-group">
//                 <label>Address</label>
//                 <input name="address" value={formData.address} onChange={handleChange} placeholder="123, Main Street, Nagpur" />
//               </div>

//               <div className="eng-section-label">Employment</div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Designation</label>
//                   <input name="designation" value={formData.designation} onChange={handleChange} placeholder="Site Engineer" />
//                 </div>
//                 <div className="eng-form-group">
//                   <label>Salary / month (₹)</label>
//                   <input name="salaryPerMonth" type="number" value={formData.salaryPerMonth} onChange={handleChange} placeholder="35000" />
//                 </div>
//               </div>

//               {/* ── NEW: Welfare Amount ── */}
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Welfare amount (₹)</label>
//                   <input
//                     name="welfareAmount"
//                     type="number"
//                     value={formData.welfareAmount}
//                     onChange={handleChange}
//                     placeholder="0"
//                     min="0"
//                   />
//                 </div>
//               </div>

//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Date of birth</label>
//                   <input name="dateOfBirth" type="date" value={formData.dateOfBirth} onChange={handleChange} />
//                 </div>
//               </div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Date of joining</label>
//                   <input name="dateOfJoining" type="date" value={formData.dateOfJoining} onChange={handleChange} />
//                 </div>
//                 <div className="eng-form-group">
//                   <label>Last working date</label>
//                   <input name="lastWorkingDate" type="date" value={formData.lastWorkingDate} onChange={handleChange} />
//                 </div>
//               </div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Status</label>
//                   <select name="engineerStatus" value={formData.engineerStatus} onChange={handleChange}>
//                     <option value="WORKING">Working</option>
//                     <option value="NOT_WORKING_RESIGNED">Resigned</option>
//                     <option value="NOT_WORKING_TERMINATED">Terminated</option>
//                     <option value="NOT_WORKING_RETIRED">Retired</option>
//                   </select>
//                 </div>
//               </div>

//               <div className="eng-section-label">Documents</div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Aadhar card</label>
//                   <label className="eng-file-upload">
//                     <span>{aadharFile ? aadharFile.name : "Choose file"}</span>
//                     <input type="file" style={{ display: "none" }} onChange={(e) => setAadharFile(e.target.files[0])} />
//                   </label>
//                 </div>
//                 <div className="eng-form-group">
//                   <label>Resume</label>
//                   <label className="eng-file-upload">
//                     <span>{resumeFile ? resumeFile.name : "Choose file"}</span>
//                     <input type="file" style={{ display: "none" }} onChange={(e) => setResumeFile(e.target.files[0])} />
//                   </label>
//                 </div>
//               </div>

//               <div className="eng-form-actions">
//                 <button type="submit" className="eng-btn-primary" style={{ flex: 1 }} disabled={submitting}>
//                   {submitting ? "Saving…" : editEngineerId ? "Save changes" : "Register engineer"}
//                 </button>
//                 <button type="button" className="eng-btn-ghost" onClick={resetForm}>Cancel</button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default Engineer;












// import React, { useEffect, useState } from "react";
// import axiosInstance from "../../utils/axiosInstance";
// import { BASE_URL } from "../../config";
// import "./Engineer.css";

// // ─── Salary Slip Generator ────────────────────────────────────────────────────
// function generateSalarySlipHTML(eng, h) {
//   const month = h.paymentMonth || "—";
//   const today = new Date().toLocaleDateString("en-IN", { day: "2-digit", month: "long", year: "numeric" });

//   return `<!DOCTYPE html>
// <html lang="en">
// <head>
// <meta charset="UTF-8"/>
// <title>Salary Slip – ${eng.name} – ${month}</title>
// <style>
//   @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display&family=DM+Sans:wght@400;500;600&display=swap');
//   *{box-sizing:border-box;margin:0;padding:0}
//   body{font-family:'DM Sans',sans-serif;background:#f4f4f0;display:flex;justify-content:center;padding:40px 16px}
//   .slip{background:#fff;width:720px;border-radius:4px;overflow:hidden;box-shadow:0 2px 16px rgba(0,0,0,.10)}
//   .header{background:#1a1a2e;color:#fff;padding:32px 40px;display:flex;justify-content:space-between;align-items:flex-start}
//   .company{font-family:'DM Serif Display',serif;font-size:22px;letter-spacing:.5px;margin-bottom:4px}
//   .header-sub{font-size:12px;opacity:.6;line-height:1.6}
//   .slip-label{text-align:right}
//   .slip-label .title{font-size:13px;letter-spacing:2px;text-transform:uppercase;opacity:.6;margin-bottom:6px}
//   .slip-label .month{font-family:'DM Serif Display',serif;font-size:20px}
//   .divider-bar{height:4px;background:linear-gradient(90deg,#e8b86d 0%,#c97d4e 100%)}
//   .body{padding:32px 40px}
//   .emp-section{display:grid;grid-template-columns:1fr 1fr;gap:16px 32px;margin-bottom:28px;padding-bottom:24px;border-bottom:1px solid #ebebeb}
//   .field label{font-size:10px;text-transform:uppercase;letter-spacing:1.5px;color:#999;display:block;margin-bottom:3px}
//   .field span{font-size:14px;color:#1a1a2e;font-weight:500}
//   .earnings-table{width:100%;border-collapse:collapse;margin-bottom:24px}
//   .earnings-table th{font-size:10px;text-transform:uppercase;letter-spacing:1.5px;color:#999;text-align:left;padding:8px 12px;background:#f9f9f7;border-bottom:2px solid #ebebeb}
//   .earnings-table td{padding:10px 12px;font-size:13px;color:#333;border-bottom:1px solid #f0f0f0}
//   .earnings-table tr:last-child td{border-bottom:none}
//   .earnings-table .amount{text-align:right;font-weight:500}
//   .total-row{background:#1a1a2e!important}
//   .total-row td{color:#fff!important;font-weight:600!important;font-size:14px!important;padding:14px 12px!important;border:none!important}
//   .status-section{display:flex;justify-content:space-between;align-items:center;background:#f9f9f7;border-radius:4px;padding:16px 20px;margin-bottom:24px}
//   .status-section .label{font-size:11px;text-transform:uppercase;letter-spacing:1.5px;color:#999;margin-bottom:4px}
//   .status-section .value{font-size:15px;font-weight:600;color:#1a1a2e}
//   .badge{display:inline-block;padding:4px 12px;border-radius:20px;font-size:11px;font-weight:600;letter-spacing:.5px;text-transform:uppercase}
//   .badge-paid{background:#e6f4ea;color:#2e7d32}
//   .badge-pending{background:#fff3f3;color:#e53935}
//   .remarks-box{background:#fffbf0;border-left:3px solid #e8b86d;padding:12px 16px;font-size:13px;color:#666;margin-bottom:24px;border-radius:0 4px 4px 0}
//   .footer{border-top:1px solid #ebebeb;padding:20px 40px;display:flex;justify-content:space-between;font-size:11px;color:#bbb;background:#fafafa}
//   .sig{text-align:right}
//   .sig-line{width:140px;border-top:1px solid #ccc;margin:28px 0 4px auto}
//   .sig-label{font-size:10px;text-transform:uppercase;letter-spacing:1px;color:#999}
//   @media print{body{background:#fff;padding:0}button{display:none!important}.slip{box-shadow:none}}
// </style>
// </head>
// <body>
// <div class="slip">
//   <div class="header">
//     <div>
//       <div class="company">Nagpur Properties</div>
//       <div class="header-sub">Nagpur, Maharashtra, India<br/></div>
//     </div>
//     <div class="slip-label">
//       <div class="title">Salary Slip</div>
//       <div class="month">${month}</div>
//     </div>
//   </div>
//   <div class="divider-bar"></div>
//   <div class="body">
//     <!-- Employee Info -->
//     <div class="emp-section">
//       <div class="field"><label>Employee Name</label><span>${eng.name || "—"}</span></div>
//       <div class="field"><label>Designation</label><span>${eng.designation || "—"}</span></div>
//       <div class="field"><label>Email</label><span>${eng.email || "—"}</span></div>
//       <div class="field"><label>Phone</label><span>${eng.phoneNumber || "—"}</span></div>
//       <div class="field"><label>Payment Month</label><span>${month}</span></div>
//       <div class="field"><label>Generated On</label><span>${today}</span></div>
//     </div>

//     <!-- Earnings Table -->
//     <table class="earnings-table">
//       <thead>
//         <tr>
//           <th>Component</th>
//           <th>Details</th>
//           <th class="amount">Amount (₹)</th>
//         </tr>
//       </thead>
//       <tbody>
//         <tr>
//           <td>Basic Salary (Monthly)</td>
//           <td>${h.daysWorked} days × ₹${h.salaryPerDay}/day</td>
//           <td class="amount">₹ ${(h.totalAmountPayable || 0).toLocaleString("en-IN")}</td>
//         </tr>
//         <tr>
//           <td>Amount Paid</td>
//           <td>Disbursed</td>
//           <td class="amount" style="color:#2e7d32">₹ ${(h.amountPaid || 0).toLocaleString("en-IN")}</td>
//         </tr>
//         <tr>
//           <td>Pending Amount</td>
//           <td>Balance due</td>
//           <td class="amount" style="color:#e53935">₹ ${(h.pendingAmount || 0).toLocaleString("en-IN")}</td>
//         </tr>
//         <tr class="total-row">
//           <td colspan="2">Net Payable</td>
//           <td class="amount">₹ ${(h.totalAmountPayable || 0).toLocaleString("en-IN")}</td>
//         </tr>
//       </tbody>
//     </table>

//     <!-- Status -->
//     <div class="status-section">
//       <div>
//         <div class="label">Payment Status</div>
//         <div class="value">${h.paymentStatus === "PAID" ? "Fully Paid" : "Pending / Partial"}</div>
//       </div>
//       <span class="badge ${h.paymentStatus === "PAID" ? "badge-paid" : "badge-pending"}">
//         ${(h.paymentStatus || "").replace(/_/g, " ")}
//       </span>
//     </div>

//     ${h.remarks ? `<div class="remarks-box"><strong>Remarks:</strong> ${h.remarks}</div>` : ""}

//     <!-- Signature -->
//     <div class="sig">
//       <div class="sig-line"></div>
//       <div class="sig-label">Authorised Signatory</div>
//     </div>
//   </div>
//   <div class="footer">
//     <span>This is a computer-generated salary slip and does not require a physical signature.</span>
//     <span>Nagpur Properties © ${new Date().getFullYear()}</span>
//   </div>
// </div>
// </body>
// </html>`;
// }

// function downloadSalarySlip(eng, h) {
//   const html = generateSalarySlipHTML(eng, h);
//   const blob = new Blob([html], { type: "text/html" });
//   const url = URL.createObjectURL(blob);
//   const a = document.createElement("a");
//   a.href = url;
//   a.download = `SalarySlip_${(eng.name || "Engineer").replace(/\s+/g, "_")}_${h.paymentMonth || "unknown"}.html`;
//   document.body.appendChild(a);
//   a.click();
//   document.body.removeChild(a);
//   URL.revokeObjectURL(url);
// }
// // ─────────────────────────────────────────────────────────────────────────────

// function Engineer() {
//   const token = JSON.parse(localStorage.getItem("NagpurProperties"))?.token;

//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [editEngineerId, setEditEngineerId] = useState(null);
//   const [engineerList, setEngineerList] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [submitting, setSubmitting] = useState(false);

//   const [statusFilter, setStatusFilter] = useState("ALL");
//   const [statusModal, setStatusModal] = useState(null);
//   const [selectedStatus, setSelectedStatus] = useState("WORKING");
//   const [statusSubmitting, setStatusSubmitting] = useState(false);
//   const [deleteModal, setDeleteModal] = useState(null);
//   const [deleteSubmitting, setDeleteSubmitting] = useState(false);

//   // ── Payment History Modal ──
//   const [historyModal, setHistoryModal] = useState(null);
//   const [historyData, setHistoryData] = useState([]);
//   const [historyLoading, setHistoryLoading] = useState(false);

//   // ── Check Salary Modal ──
//   const [checkSalaryModal, setCheckSalaryModal] = useState(null);
//   const [checkSalaryMonth, setCheckSalaryMonth] = useState("");
//   const [checkSalaryData, setCheckSalaryData] = useState(null);
//   const [checkSalaryLoading, setCheckSalaryLoading] = useState(false);

//   const emptyForm = {
//     name: "",
//     email: "",
//     phoneNumber: "",
//     password: "",
//     bloodGroup: "",
//     panNumber: "",
//     aadharNumber: "",
//     emergencyContact: "",
//     designation: "",
//     salaryPerMonth: "",
//     salaryPerDay: "",       // ← NEW
//     welfareAmount: "",
//     address: "",
//     dateOfJoining: "",
//     dateOfBirth: "",
//     lastWorkingDate: "",
//     engineerStatus: "WORKING",
//   };

//   const [formData, setFormData] = useState(emptyForm);

//   const [aadharFile, setAadharFile] = useState(null);
//   const [resumeFile, setResumeFile] = useState(null);

//   // ─── HELPERS ─────────────────────────────────
//   const initials = (name = "") =>
//     name.trim().split(" ").slice(0, 2).map((w) => w[0]?.toUpperCase() || "").join("");

//   const filteredList = engineerList.filter((e) => {
//     const matchesSearch =
//       (e.name || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
//       (e.email || "").toLowerCase().includes(searchQuery.toLowerCase());
//     const matchesStatus =
//       statusFilter === "ALL" || e.engineerStatus === statusFilter;
//     return matchesSearch && matchesStatus;
//   });

//   const stats = {
//     total: engineerList.length,
//     active: engineerList.filter((e) => e.engineerStatus === "WORKING").length,
//     designations: new Set(engineerList.map((e) => e.designation).filter(Boolean)).size,
//   };

//   const statusLabel = (status) => {
//     if (!status || status === "WORKING") return "Working";
//     return status.replace("NOT_WORKING_", "").replace(/_/g, " ");
//   };

//   const formatStatus = (status) => status ? status.replace(/_/g, " ") : "-";

//   // ─── FORM HANDLERS ───────────────────────────
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const resetForm = () => {
//     setFormData(emptyForm);
//     setAadharFile(null);
//     setResumeFile(null);
//     setEditEngineerId(null);
//     setDrawerOpen(false);
//   };

//   useEffect(() => {
//     if (formData.lastWorkingDate) {
//       setFormData((prev) => ({ ...prev, engineerStatus: "NOT_WORKING_RESIGNED" }));
//     }
//   }, [formData.lastWorkingDate]);

//   const buildRegisterFormData = () => {
//     const data = new FormData();
//     const dto = {};
//     Object.keys(formData).forEach((key) => {
//       if (formData[key] !== "" && formData[key] !== null && formData[key] !== undefined)
//         dto[key] = formData[key];
//     });
//     data.append("engineerDto", new Blob([JSON.stringify(dto)], { type: "application/json" }));
//     if (aadharFile) data.append("aadharCardImg", aadharFile);
//     if (resumeFile) data.append("resume", resumeFile);
//     return data;
//   };

//   const buildUpdateFormData = () => {
//     const data = new FormData();
//     const { engineerStatus, ...rest } = formData;
//     const dto = {};
//     Object.keys(rest).forEach((key) => {
//       if (rest[key] !== "" && rest[key] !== null && rest[key] !== undefined)
//         dto[key] = rest[key];
//     });
//     data.append("request", new Blob([JSON.stringify(dto)], { type: "application/json" }));
//     data.append("engineerStatus", new Blob([JSON.stringify(engineerStatus)], { type: "application/json" }));
//     if (aadharFile) data.append("aadharCardImg", aadharFile);
//     if (resumeFile) data.append("resume", resumeFile);
//     return data;
//   };

//   // ─── API CALLS ───────────────────────────────
//   async function getEngineerList() {
//     try {
//       const response = await axiosInstance.get(`${BASE_URL}/allEngineers`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setEngineerList(response.data.sort((a, b) => b.id - a.id));
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   }

//   async function fetchEngineerById(id) {
//     try {
//       const response = await axiosInstance.get(`${BASE_URL}/engineer/${id}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       return response.data;
//     } catch (error) {
//       console.error(error);
//       alert("Failed to fetch engineer details");
//       return null;
//     }
//   }

//   // ── Payment History ───────────────────────────
//   async function openHistoryModal(eng) {
//     setHistoryModal({
//       id: eng.id,
//       name: eng.name,
//       email: eng.email,
//       phoneNumber: eng.phoneNumber,
//       designation: eng.designation,
//     });
//     setHistoryData([]);
//     setHistoryLoading(true);
//     try {
//       const response = await axiosInstance.get(
//         `${BASE_URL}/engineer/${eng.id}/payment/history`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       setHistoryData(response.data);
//     } catch (error) {
//       console.error(error);
//       alert(error?.response?.data?.message || "Failed to fetch payment history");
//       setHistoryModal(null);
//     } finally {
//       setHistoryLoading(false);
//     }
//   }

//   // ── Check Salary ──────────────────────────────
//   function openCheckSalaryModal(eng) {
//     setCheckSalaryModal({ id: eng.id, name: eng.name });
//     setCheckSalaryMonth("");
//     setCheckSalaryData(null);
//   }

//   async function handleCheckSalary() {
//     if (!checkSalaryMonth) { alert("Please select a month"); return; }
//     const formattedMonth = checkSalaryMonth.slice(0, 7) + "-01";
//     setCheckSalaryLoading(true);
//     setCheckSalaryData(null);
//     try {
//       const response = await axiosInstance.post(
//         `${BASE_URL}/engineer/${checkSalaryModal.id}/payment/generate`,
//         null,
//         {
//           params: {
//             engineerId: checkSalaryModal.id,
//             paymentMonth: formattedMonth,
//           },
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       setCheckSalaryData(response.data);
//     } catch (error) {
//       console.error(error);
//       alert(error?.response?.data?.message || "Failed to fetch salary info");
//     } finally {
//       setCheckSalaryLoading(false);
//     }
//   }

//   async function handleAddEngineer(e) {
//     e.preventDefault();
//     setSubmitting(true);
//     try {
//       const response = await axiosInstance.post(
//         `${BASE_URL}/registerEngineer`,
//         buildRegisterFormData(),
//         { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
//       );
//       if (response.status === 200) {
//         alert("Engineer Registered Successfully");
//         resetForm();
//         getEngineerList();
//       }
//     } catch (error) {
//       let message = "Something went wrong";
//       if (error.response) {
//         const { status, data } = error.response;
//         if (status === 409) message = data?.message || "Email already exists";
//         else if (status === 400) message = data?.message || "Invalid data";
//         else if (status === 401) message = "Unauthorized. Please login again.";
//         else if (status === 500) message = data?.message || "Server error. Try again later.";
//         else message = data?.message || `Error: ${status}`;
//       } else if (error.request) {
//         message = "No response from server. Check your connection.";
//       } else {
//         message = error.message;
//       }
//       alert(message);
//     } finally {
//       setSubmitting(false);
//     }
//   }

//   async function handleEditEngineerRegistration(e) {
//     e.preventDefault();
//     setSubmitting(true);
//     try {
//       const response = await axiosInstance.put(
//         `${BASE_URL}/engineer/update/${editEngineerId}`,
//         buildUpdateFormData(),
//         { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
//       );
//       if (response.status === 200) {
//         alert("Engineer Updated Successfully");
//         resetForm();
//         getEngineerList();
//       }
//     } catch (error) {
//       alert(error?.response?.data?.message || "Update failed");
//     } finally {
//       setSubmitting(false);
//     }
//   }

//   async function handleDeleteEngineer() {
//     setDeleteSubmitting(true);
//     try {
//       const response = await axiosInstance.delete(
//         `${BASE_URL}/deleteEngineer/${deleteModal.id}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       if (response.status === 200) {
//         alert("Engineer Deleted Successfully");
//         setDeleteModal(null);
//         getEngineerList();
//       }
//     } catch (error) {
//       alert(error?.response?.data?.message || "Delete failed");
//     } finally {
//       setDeleteSubmitting(false);
//     }
//   }

//   function openStatusModal(eng) {
//     setStatusModal({ id: eng.id, name: eng.name });
//     setSelectedStatus(eng.engineerStatus || "WORKING");
//   }

//   async function handleStatusUpdate() {
//     setStatusSubmitting(true);
//     try {
//       const response = await axiosInstance.patch(
//         `${BASE_URL}/engineer/update/${statusModal.id}/status?engineerStatus=${selectedStatus}`,
//         null,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       if (response.status === 200) {
//         alert("Status Updated Successfully");
//         setStatusModal(null);
//         getEngineerList();
//       }
//     } catch (error) {
//       alert(error?.response?.data?.message || "Status update failed");
//     } finally {
//       setStatusSubmitting(false);
//     }
//   }

//   async function openEditDrawer(engineer) {
//     const data = await fetchEngineerById(engineer.id);
//     if (!data) return;
//     setEditEngineerId(data.id);
//     setFormData({
//       name: data.name || "",
//       email: data.email || "",
//       phoneNumber: data.phoneNumber || "",
//       password: "",
//       bloodGroup: data.bloodGroup || "",
//       panNumber: data.panNumber || "",
//       aadharNumber: data.aadharNumber || "",
//       emergencyContact: data.emergencyContact || "",
//       designation: data.designation || "",
//       salaryPerMonth: data.salaryPerMonth != null ? String(data.salaryPerMonth) : "",
//       salaryPerDay: data.salaryPerDay != null ? String(data.salaryPerDay) : "",   // ← NEW
//       welfareAmount: data.welfareAmount != null ? String(data.welfareAmount) : "",
//       address: data.address || "",
//       dateOfJoining: data.dateOfJoining || "",
//       dateOfBirth: data.dateOfBirth || "",
//       lastWorkingDate: data.lastWorkingDate || "",
//       engineerStatus: data.engineerStatus || "WORKING",
//     });
//     setDrawerOpen(true);
//   }

//   useEffect(() => { getEngineerList(); }, []);

//   // ─── RENDER ──────────────────────────────────
//   return (
//     <div className="eng-page">

//       {/* TOP BAR */}
//       <div className="eng-topbar">
//         <div>
//           <h2 className="eng-page-title">Engineers</h2>
//           <p className="eng-page-sub">Manage your engineering team</p>
//         </div>
//         <button className="eng-btn-primary" onClick={() => { resetForm(); setDrawerOpen(true); }}>
//           + Add engineer
//         </button>
//       </div>

//       {/* STAT CARDS */}
//       <div className="eng-stats">
//         <div className="eng-stat-card">
//           <div className="eng-stat-label">Total engineers</div>
//           <div className="eng-stat-value">{stats.total}</div>
//         </div>
//         <div className="eng-stat-card">
//           <div className="eng-stat-label">Active</div>
//           <div className="eng-stat-value eng-stat-green">{stats.active}</div>
//         </div>
//         <div className="eng-stat-card">
//           <div className="eng-stat-label">Designations</div>
//           <div className="eng-stat-value">{stats.designations}</div>
//         </div>
//       </div>

//       {/* TABLE */}
//       <div className="eng-table-card">
//         <div className="eng-table-header">
//           <span className="eng-table-title">Team roster</span>
//           <div className="eng-filter-wrapper">
//             <select
//               className="eng-status-filter"
//               value={statusFilter}
//               onChange={(e) => setStatusFilter(e.target.value)}
//             >
//               <option value="ALL">All Status</option>
//               <option value="WORKING">Working</option>
//               <option value="NOT_WORKING_RESIGNED">Resigned</option>
//               <option value="NOT_WORKING_TERMINATED">Terminated</option>
//               <option value="NOT_WORKING_RETIRED">Retired</option>
//             </select>
//             <span className="eng-filter-icon">⌄</span>
//           </div>
//           <div className="eng-table-controls">
//             <input
//               className="eng-search"
//               placeholder="Search by name or email…"
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//             />
//           </div>
//         </div>

//         {loading ? (
//           <div className="eng-empty">Loading engineers…</div>
//         ) : filteredList.length === 0 ? (
//           <div className="eng-empty">No engineers found.</div>
//         ) : (
//           <table className="eng-table">
//             <thead>
//               <tr>
//                 <th>Name</th>
//                 <th>Email</th>
//                 <th>Phone</th>
//                 <th>Designation</th>
//                 <th>Status</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredList.map((eng) => (
//                 <tr key={eng.id}>
//                   <td>
//                     <div className="eng-name-cell">
//                       <div className="eng-avatar">{initials(eng.name)}</div>
//                       <span>{eng.name || "—"}</span>
//                     </div>
//                   </td>
//                   <td className="eng-muted">{eng.email || "—"}</td>
//                   <td>{eng.phoneNumber || "—"}</td>
//                   <td className="eng-muted">{eng.designation || "—"}</td>
//                   <td>
//                     <span className={`eng-badge ${eng.engineerStatus === "WORKING" ? "eng-badge-active" : "eng-badge-inactive"}`}>
//                       {statusLabel(eng.engineerStatus)}
//                     </span>
//                   </td>
//                   <td>
//                     <div className="eng-action-btns">
//                       <button className="eng-btn-ghost eng-btn-sm" onClick={() => openEditDrawer(eng)}>
//                         Edit
//                       </button>
//                       <button className="eng-btn-status eng-btn-sm" onClick={() => openStatusModal(eng)}>
//                         Status
//                       </button>
//                       <button
//                         className="eng-btn-ghost eng-btn-sm"
//                         onClick={() => openCheckSalaryModal(eng)}
//                       >
//                         Check Salary
//                       </button>
//                       <button
//                         className="eng-btn-delete eng-btn-sm"
//                         onClick={() => openHistoryModal(eng)}
//                       >
//                         Payment History
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         )}
//       </div>

//       {/* CHECK SALARY MODAL */}
//       {checkSalaryModal && (
//         <div
//           style={{
//             position: "fixed", inset: 0,
//             background: "rgba(0,0,0,0.45)",
//             display: "flex", alignItems: "center", justifyContent: "center",
//             zIndex: 999,
//           }}
//           onClick={() => setCheckSalaryModal(null)}
//         >
//           <div
//             style={{
//               background: "#fff", borderRadius: "12px",
//               padding: "1.5rem", width: "95%", maxWidth: "460px",
//               boxShadow: "0 4px 24px rgba(0,0,0,0.15)",
//             }}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}>
//               <div>
//                 <h3 style={{ margin: 0 }}>Check Salary</h3>
//                 <p style={{ fontSize: "13px", color: "#666", margin: "2px 0 0" }}>
//                   {checkSalaryModal.name}
//                 </p>
//               </div>
//               <button className="eng-btn-ghost" onClick={() => setCheckSalaryModal(null)}>
//                 ✕
//               </button>
//             </div>

//             <label style={{ fontSize: "13px", color: "#555", display: "block", marginBottom: "4px" }}>
//               Select Month
//             </label>
//             <div style={{ display: "flex", gap: "8px", marginBottom: "1.25rem" }}>
//               <input
//                 type="date"
//                 value={checkSalaryMonth}
//                 onChange={(e) => { setCheckSalaryMonth(e.target.value); setCheckSalaryData(null); }}
//                 className="eng-search"
//                 style={{ flex: 1 }}
//               />
//               <button
//                 className="eng-btn-primary"
//                 onClick={handleCheckSalary}
//                 disabled={checkSalaryLoading}
//               >
//                 {checkSalaryLoading ? "Loading..." : "Check"}
//               </button>
//             </div>

//             {checkSalaryData && (
//               <>
//                 <div style={{
//                   display: "grid", gridTemplateColumns: "1fr 1fr",
//                   gap: "10px", marginBottom: "1rem",
//                 }}>
//                   <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "12px" }}>
//                     <p style={{ fontSize: "11px", color: "#888", margin: "0 0 2px" }}>Days Worked</p>
//                     <p style={{ fontSize: "18px", fontWeight: 500, margin: 0 }}>{checkSalaryData.daysWorked}</p>
//                   </div>
//                   <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "12px" }}>
//                     <p style={{ fontSize: "11px", color: "#888", margin: "0 0 2px" }}>Salary / Day</p>
//                     <p style={{ fontSize: "18px", fontWeight: 500, margin: 0 }}>₹ {checkSalaryData.salaryPerDay}</p>
//                   </div>
//                   <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "12px" }}>
//                     <p style={{ fontSize: "11px", color: "#888", margin: "0 0 2px" }}>Total Payable</p>
//                     <p style={{ fontSize: "18px", fontWeight: 500, margin: 0 }}>₹ {checkSalaryData.totalAmountPayable}</p>
//                   </div>
//                   <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "12px" }}>
//                     <p style={{ fontSize: "11px", color: "#888", margin: "0 0 2px" }}>Amount Paid</p>
//                     <p style={{ fontSize: "18px", fontWeight: 500, color: "#2e7d32", margin: 0 }}>₹ {checkSalaryData.amountPaid}</p>
//                   </div>
//                 </div>

//                 <div style={{
//                   display: "flex", alignItems: "center", justifyContent: "space-between",
//                   background: "#fff3f3", borderRadius: "8px", padding: "12px 16px",
//                   marginBottom: "1rem",
//                 }}>
//                   <div>
//                     <p style={{ fontSize: "11px", color: "#888", margin: "0 0 2px" }}>Pending Amount</p>
//                     <p style={{ fontSize: "18px", fontWeight: 500, color: "#e53935", margin: 0 }}>
//                       ₹ {checkSalaryData.pendingAmount}
//                     </p>
//                   </div>
//                   <span className={`eng-badge ${checkSalaryData.paymentStatus === "PAID" ? "eng-badge-active" : "eng-badge-inactive"}`}>
//                     {formatStatus(checkSalaryData.paymentStatus)}
//                   </span>
//                 </div>

//                 {checkSalaryData.remarks && (
//                   <p style={{ fontSize: "13px", color: "#666", margin: 0 }}>
//                     <strong>Remarks:</strong> {checkSalaryData.remarks}
//                   </p>
//                 )}
//               </>
//             )}

//             <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "1rem" }}>
//               <button className="eng-btn-ghost" onClick={() => setCheckSalaryModal(null)}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* PAYMENT HISTORY MODAL */}
//       {historyModal && (
//         <div
//           style={{
//             position: "fixed", inset: 0,
//             background: "rgba(0,0,0,0.45)",
//             display: "flex", alignItems: "center", justifyContent: "center",
//             zIndex: 999,
//           }}
//           onClick={() => setHistoryModal(null)}
//         >
//           <div
//             style={{
//               background: "#fff", borderRadius: "12px",
//               padding: "1.5rem", width: "95%", maxWidth: "900px",
//               maxHeight: "80vh", overflowY: "auto",
//               boxShadow: "0 4px 24px rgba(0,0,0,0.15)",
//             }}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}>
//               <div>
//                 <h3 style={{ margin: 0 }}>Payment History</h3>
//                 <p style={{ fontSize: "13px", color: "#666", margin: "2px 0 0" }}>{historyModal.name}</p>
//               </div>
//               <button className="eng-btn-ghost" onClick={() => setHistoryModal(null)}>✕ Close</button>
//             </div>

//             {historyLoading && (
//               <div style={{ textAlign: "center", padding: "2rem", color: "#888" }}>Loading payment history...</div>
//             )}

//             {!historyLoading && historyData.length === 0 && (
//               <div style={{ textAlign: "center", padding: "2rem", color: "#888" }}>No payment records found.</div>
//             )}

//             {!historyLoading && historyData.length > 0 && (
//               <>
//                 <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "10px", marginBottom: "1rem" }}>
//                   <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "12px" }}>
//                     <p style={{ fontSize: "11px", color: "#888", margin: "0 0 2px" }}>Total Payable</p>
//                     <p style={{ fontSize: "15px", fontWeight: 500, margin: 0 }}>
//                       ₹ {historyData.reduce((sum, h) => sum + (h.totalAmountPayable || 0), 0).toLocaleString()}
//                     </p>
//                   </div>
//                   <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "12px" }}>
//                     <p style={{ fontSize: "11px", color: "#888", margin: "0 0 2px" }}>Total Paid</p>
//                     <p style={{ fontSize: "15px", fontWeight: 500, color: "#2e7d32", margin: 0 }}>
//                       ₹ {historyData.reduce((sum, h) => sum + (h.amountPaid || 0), 0).toLocaleString()}
//                     </p>
//                   </div>
//                   <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "12px" }}>
//                     <p style={{ fontSize: "11px", color: "#888", margin: "0 0 2px" }}>Total Pending</p>
//                     <p style={{ fontSize: "15px", fontWeight: 500, color: "#e53935", margin: 0 }}>
//                       ₹ {historyData.reduce((sum, h) => sum + (h.pendingAmount || 0), 0).toLocaleString()}
//                     </p>
//                   </div>
//                 </div>

//                 <table className="eng-table">
//                   <thead>
//                     <tr>
//                       <th>Month</th>
//                       <th>Days Worked</th>
//                       <th>Salary/Day</th>
//                       <th>Payable</th>
//                       <th>Paid</th>
//                       <th>Pending</th>
//                       <th>Status</th>
//                       <th>Remarks</th>
//                       <th>Salary Slip</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {historyData.map((h) => (
//                       <tr key={h.paymentId}>
//                         <td>{h.paymentMonth}</td>
//                         <td>{h.daysWorked}</td>
//                         <td>₹ {h.salaryPerDay}</td>
//                         <td>₹ {h.totalAmountPayable}</td>
//                         <td>₹ {h.amountPaid}</td>
//                         <td>₹ {h.pendingAmount}</td>
//                         <td>
//                           <span className={`eng-badge ${h.paymentStatus === "PAID" ? "eng-badge-active" : "eng-badge-inactive"}`}>
//                             {formatStatus(h.paymentStatus)}
//                           </span>
//                         </td>
//                         <td style={{ fontSize: "12px", color: "#666" }}>{h.remarks || "—"}</td>
//                         <td>
//                           <button
//                             className="eng-btn-ghost eng-btn-sm"
//                             title={`Download salary slip for ${h.paymentMonth}`}
//                             onClick={() => downloadSalarySlip(historyModal, h)}
//                             style={{ display: "inline-flex", alignItems: "center", gap: "4px", whiteSpace: "nowrap" }}
//                           >
//                             ⬇ Slip
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </>
//             )}
//           </div>
//         </div>
//       )}

//       {/* DELETE CONFIRM MODAL */}
//       {deleteModal && (
//         <div className="eng-modal-overlay" onClick={() => setDeleteModal(null)}>
//           <div className="eng-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="eng-modal-header">
//               <h3 className="eng-modal-title">Delete Engineer</h3>
//               <button className="eng-close-btn" onClick={() => setDeleteModal(null)}>✕</button>
//             </div>
//             <p className="eng-modal-name" style={{ marginBottom: 8 }}>
//               Are you sure you want to delete <strong>{deleteModal.name}</strong>?
//             </p>
//             <p style={{ fontSize: 13, color: "var(--eng-muted, #6b7280)", marginBottom: 20 }}>
//               This action cannot be undone.
//             </p>
//             <div className="eng-modal-actions">
//               <button
//                 className="eng-btn-delete-confirm"
//                 style={{ flex: 1 }}
//                 onClick={handleDeleteEngineer}
//                 disabled={deleteSubmitting}
//               >
//                 {deleteSubmitting ? "Deleting…" : "Yes, Delete"}
//               </button>
//               <button className="eng-btn-ghost" onClick={() => setDeleteModal(null)}>Cancel</button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* STATUS MODAL */}
//       {statusModal && (
//         <div className="eng-modal-overlay" onClick={() => setStatusModal(null)}>
//           <div className="eng-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="eng-modal-header">
//               <h3 className="eng-modal-title">Update Status</h3>
//               <button className="eng-close-btn" onClick={() => setStatusModal(null)}>✕</button>
//             </div>
//             <p className="eng-modal-name">{statusModal.name}</p>
//             <div className="eng-status-options">
//               {[
//                 { value: "WORKING", label: "Working" },
//                 { value: "NOT_WORKING_RESIGNED", label: "Resigned" },
//                 { value: "NOT_WORKING_TERMINATED", label: "Terminated" },
//                 { value: "NOT_WORKING_RETIRED", label: "Retired" },
//               ].map((opt) => (
//                 <label key={opt.value} className={`eng-status-option ${selectedStatus === opt.value ? "selected" : ""}`}>
//                   <input
//                     type="radio"
//                     name="statusPick"
//                     value={opt.value}
//                     checked={selectedStatus === opt.value}
//                     onChange={() => setSelectedStatus(opt.value)}
//                   />
//                   <span className={`eng-badge ${opt.value === "WORKING" ? "eng-badge-active" : "eng-badge-inactive"}`}>
//                     {opt.label}
//                   </span>
//                 </label>
//               ))}
//             </div>
//             <div className="eng-modal-actions">
//               <button
//                 className="eng-btn-primary"
//                 style={{ flex: 1 }}
//                 onClick={handleStatusUpdate}
//                 disabled={statusSubmitting}
//               >
//                 {statusSubmitting ? "Saving…" : "Update Status"}
//               </button>
//               <button className="eng-btn-ghost" onClick={() => setStatusModal(null)}>Cancel</button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* DRAWER */}
//       {drawerOpen && (
//         <div className="eng-overlay" onClick={resetForm}>
//           <div className="eng-drawer" onClick={(e) => e.stopPropagation()}>
//             <div className="eng-drawer-header">
//               <h3 className="eng-drawer-title">
//                 {editEngineerId ? "Update engineer" : "Register engineer"}
//               </h3>
//               <button className="eng-close-btn" onClick={resetForm}>✕</button>
//             </div>

//             <form onSubmit={editEngineerId ? handleEditEngineerRegistration : handleAddEngineer}>
//               <div className="eng-section-label">Basic information</div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Full name *</label>
//                   <input name="name" value={formData.name} onChange={handleChange} placeholder="Rahul Sharma" required />
//                 </div>
//                 <div className="eng-form-group">
//                   <label>Email *</label>
//                   <input name="email" type="email" value={formData.email} onChange={handleChange} placeholder="rahul@company.com" required />
//                 </div>
//               </div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Phone *</label>
//                   <input name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} placeholder="+91 98765 43210" required />
//                 </div>
//                 {!editEngineerId && (
//                   <div className="eng-form-group">
//                     <label>Password *</label>
//                     <input name="password" type="password" value={formData.password} onChange={handleChange} placeholder="••••••••" required />
//                   </div>
//                 )}
//               </div>

//               <div className="eng-section-label">Personal details</div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Blood group</label>
//                   <input name="bloodGroup" value={formData.bloodGroup} onChange={handleChange} placeholder="B+" />
//                 </div>
//                 <div className="eng-form-group">
//                   <label>Emergency contact</label>
//                   <input name="emergencyContact" value={formData.emergencyContact} onChange={handleChange} placeholder="+91 ..." />
//                 </div>
//               </div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>PAN number</label>
//                   <input name="panNumber" value={formData.panNumber} onChange={handleChange} placeholder="ABCDE1234F" />
//                 </div>
//                 <div className="eng-form-group">
//                   <label>Aadhar number</label>
//                   <input name="aadharNumber" value={formData.aadharNumber} onChange={handleChange} placeholder="1234 5678 9012" />
//                 </div>
//               </div>
//               <div className="eng-form-group">
//                 <label>Address</label>
//                 <input name="address" value={formData.address} onChange={handleChange} placeholder="123, Main Street, Nagpur" />
//               </div>

//               <div className="eng-section-label">Employment</div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Designation</label>
//                   <input name="designation" value={formData.designation} onChange={handleChange} placeholder="Site Engineer" />
//                 </div>
//                 <div className="eng-form-group">
//                   <label>Salary / month (₹)</label>
//                   <input name="salaryPerMonth" type="number" value={formData.salaryPerMonth} onChange={handleChange} placeholder="35000" />
//                 </div>
//               </div>

//               {/* ── NEW: Salary per day + Welfare amount ── */}
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Salary / day (₹)</label>
//                   <input
//                     name="salaryPerDay"
//                     type="number"
//                     value={formData.salaryPerDay}
//                     onChange={handleChange}
//                     placeholder="0"
//                     min="0"
//                   />
//                 </div>
//                 <div className="eng-form-group">
//                   <label>Welfare amount (₹)</label>
//                   <input
//                     name="welfareAmount"
//                     type="number"
//                     value={formData.welfareAmount}
//                     onChange={handleChange}
//                     placeholder="0"
//                     min="0"
//                   />
//                 </div>
//               </div>

//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Date of birth</label>
//                   <input name="dateOfBirth" type="date" value={formData.dateOfBirth} onChange={handleChange} />
//                 </div>
//               </div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Date of joining</label>
//                   <input name="dateOfJoining" type="date" value={formData.dateOfJoining} onChange={handleChange} />
//                 </div>
//                 <div className="eng-form-group">
//                   <label>Last working date</label>
//                   <input name="lastWorkingDate" type="date" value={formData.lastWorkingDate} onChange={handleChange} />
//                 </div>
//               </div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Status</label>
//                   <select name="engineerStatus" value={formData.engineerStatus} onChange={handleChange}>
//                     <option value="WORKING">Working</option>
//                     <option value="NOT_WORKING_RESIGNED">Resigned</option>
//                     <option value="NOT_WORKING_TERMINATED">Terminated</option>
//                     <option value="NOT_WORKING_RETIRED">Retired</option>
//                   </select>
//                 </div>
//               </div>

//               <div className="eng-section-label">Documents</div>
//               <div className="eng-form-row">
//                 <div className="eng-form-group">
//                   <label>Aadhar card</label>
//                   <label className="eng-file-upload">
//                     <span>{aadharFile ? aadharFile.name : "Choose file"}</span>
//                     <input type="file" style={{ display: "none" }} onChange={(e) => setAadharFile(e.target.files[0])} />
//                   </label>
//                 </div>
//                 <div className="eng-form-group">
//                   <label>Resume</label>
//                   <label className="eng-file-upload">
//                     <span>{resumeFile ? resumeFile.name : "Choose file"}</span>
//                     <input type="file" style={{ display: "none" }} onChange={(e) => setResumeFile(e.target.files[0])} />
//                   </label>
//                 </div>
//               </div>

//               <div className="eng-form-actions">
//                 <button type="submit" className="eng-btn-primary" style={{ flex: 1 }} disabled={submitting}>
//                   {submitting ? "Saving…" : editEngineerId ? "Save changes" : "Register engineer"}
//                 </button>
//                 <button type="button" className="eng-btn-ghost" onClick={resetForm}>Cancel</button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default Engineer;

























import React, { useEffect, useState } from "react";
import axiosInstance from "../../utils/axiosInstance";
import { BASE_URL } from "../../config";
import PaymentService from "../Engineer/paymentService";
import "./Engineer.css";

// ─────────────────────────────────────────────────────────────────────────────
// ROLE HELPERS
// Shared shape with EngineerAttendance.jsx / EngineerLeave.jsx:
//   localStorage "NagpurProperties" = { token, id, name, role: [{ roleName }] }
// If your actual role strings differ from what's checked below, update the
// variant list in one place — it's only defined here, not duplicated per view.
// ─────────────────────────────────────────────────────────────────────────────
function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem("NagpurProperties")) || {};
  } catch {
    return {};
  }
}

function getRoleNames(user) {
  const roles = Array.isArray(user?.role) ? user.role : [];
  return roles.map((r) => (r?.roleName || "").trim().toUpperCase());
}

const ADMIN_ROLE_VARIANTS = ["ADMIN", "SUPERENGINEER", "SUPER_ENGINEER", "SUPER ENGINEER"];

// ─────────────────────────────────────────────────────────────────────────────
// SELF-SERVICE PROFILE VIEW (plain "Engineer" role)
//
// Deliberately READ-ONLY and deliberately calls only `/engineer/{id}` for the
// logged-in engineer's own id — never `/allEngineers`. A plain engineer has
// no code path here to see anyone else's salary, Aadhar number, address, or
// contact details.
//
// Editing is intentionally NOT wired up here even though `/engineer/update/
// {id}` exists: that endpoint's request body includes engineerStatus and
// salary fields, and whether it's safe to expose to a self-service caller
// depends entirely on whether the BACKEND itself restricts which fields a
// non-admin caller may change — a frontend-only restriction (e.g. hiding the
// salary input) is not real access control if the same endpoint is called
// with a raw request. If you want engineers to edit a few safe fields
// themselves (address, emergency contact, blood group), the backend should
// expose a narrower endpoint scoped to just those fields; wire that here
// rather than reusing the admin update endpoint with fields hidden in the UI.
// ─────────────────────────────────────────────────────────────────────────────
function MyEngineerProfile({ engineerId, token }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      if (!engineerId) return;
      setLoading(true);
      setError(null);
      try {
        const response = await axiosInstance.get(`${BASE_URL}/engineer/${engineerId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!cancelled) setData(response.data);
      } catch (err) {
        if (!cancelled) setError(err?.response?.data?.message || "Failed to load your profile");
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => { cancelled = true; };
  }, [engineerId, token]);

  const initials = (name = "") =>
    name.trim().split(" ").slice(0, 2).map((w) => w[0]?.toUpperCase() || "").join("");

  const statusLabel = (status) => {
    if (!status || status === "WORKING") return "Working";
    return status.replace("NOT_WORKING_", "").replace(/_/g, " ");
  };

  const fmtMoney = (n) =>
    typeof n === "number" ? n.toLocaleString("en-IN", { style: "currency", currency: "INR", minimumFractionDigits: 0 }) : "—";

  if (loading) {
    return (
      <div className="eng-page">
        <div className="eng-empty">Loading your profile…</div>
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="eng-page">
        <div className="eng-empty">{error || "No profile data found."}</div>
      </div>
    );
  }

  return (
    <div className="eng-page">
      <div className="eng-topbar">
        <div>
          <h2 className="eng-page-title">My Profile</h2>
          <p className="eng-page-sub">Your employment details on file</p>
        </div>
      </div>

      <div className="eng-table-card" style={{ padding: "1.5rem" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: "1.5rem" }}>
          <div className="eng-avatar" style={{ width: 56, height: 56, fontSize: 18 }}>
            {initials(data.name)}
          </div>
          <div>
            <div style={{ fontSize: "17px", fontWeight: 600 }}>{data.name || "—"}</div>
            <div style={{ fontSize: "13px", color: "#6b7280" }}>{data.designation || "—"}</div>
          </div>
          <span
            className={`eng-badge ${data.engineerStatus === "WORKING" ? "eng-badge-active" : "eng-badge-inactive"}`}
            style={{ marginLeft: "auto" }}
          >
            {statusLabel(data.engineerStatus)}
          </span>
        </div>

        <div className="eng-section-label">Contact</div>
        <div className="eng-form-row">
          <div className="eng-form-group"><label>Email</label><div>{data.email || "—"}</div></div>
          <div className="eng-form-group"><label>Phone</label><div>{data.phoneNumber || "—"}</div></div>
        </div>
        <div className="eng-form-group"><label>Address</label><div>{data.address || "—"}</div></div>

        <div className="eng-section-label">Employment</div>
        <div className="eng-form-row">
          <div className="eng-form-group"><label>Date of Joining</label><div>{data.dateOfJoining || "—"}</div></div>
          <div className="eng-form-group"><label>Last Working Date</label><div>{data.lastWorkingDate || "—"}</div></div>
        </div>

        <div className="eng-section-label">Salary</div>
        <div className="eng-form-row">
          <div className="eng-form-group"><label>Per Month</label><div>{fmtMoney(data.salaryPerMonth)}</div></div>
          <div className="eng-form-group"><label>Per Day</label><div>{fmtMoney(data.salaryPerDay)}</div></div>
        </div>
        <div className="eng-form-group"><label>Welfare Amount</label><div>{fmtMoney(data.welfareAmount)}</div></div>

        <div className="eng-section-label">Personal</div>
        <div className="eng-form-row">
          <div className="eng-form-group"><label>Date of Birth</label><div>{data.dateOfBirth || "—"}</div></div>
          <div className="eng-form-group"><label>Blood Group</label><div>{data.bloodGroup || "—"}</div></div>
        </div>
        <div className="eng-form-group"><label>Emergency Contact</label><div>{data.emergencyContact || "—"}</div></div>

        <div className="eng-section-label">Identity Documents</div>
        <div className="eng-form-row">
          <div className="eng-form-group"><label>Aadhar Number</label><div>{data.aadharNumber || "—"}</div></div>
          <div className="eng-form-group"><label>PAN Number</label><div>{data.panNumber || "—"}</div></div>
        </div>

        <p style={{ fontSize: "12px", color: "#9ca3af", marginTop: "1.5rem" }}>
          Need something changed here? Contact an admin — profile edits go through HR/admin review.
        </p>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// ADMIN / SUPERENGINEER DASHBOARD (full roster, payments, everything below)
// This is your original Engineer() component, unchanged in behavior, just
// extracted into its own component so it can be gated behind isAdmin instead
// of always mounting and always calling /allEngineers.
// ─────────────────────────────────────────────────────────────────────────────
function AdminEngineerDashboard() {
  const token = getStoredUser()?.token;
  const adminUsername = getStoredUser()?.username || getStoredUser()?.name || "Admin";
  const paymentService = new PaymentService(token);

  // ─── EXISTING STATE ──────────────────────────────────────────
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editEngineerId, setEditEngineerId] = useState(null);
  const [engineerList, setEngineerList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [statusFilter, setStatusFilter] = useState("ALL");
  const [statusModal, setStatusModal] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("WORKING");
  const [statusSubmitting, setStatusSubmitting] = useState(false);
  const [deleteModal, setDeleteModal] = useState(null);
  const [deleteSubmitting, setDeleteSubmitting] = useState(false);

  // ─── PAYMENT MANAGEMENT STATE ────────────────────────────────
  const [paymentsModal, setPaymentsModal] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [paymentsData, setPaymentsData] = useState([]);
  const [paymentsLoading, setPaymentsLoading] = useState(false);

  const [paymentEditModal, setPaymentEditModal] = useState(null);
  const [paymentEditData, setPaymentEditData] = useState({
    petrolAllowance: 0,
    lateDayDeduction: 0,
    advanceDeduction: 0,
    editRemark: "",
  });
  const [paymentEditLoading, setPaymentEditLoading] = useState(false);
  const [paymentMarkPaidLoading, setPaymentMarkPaidLoading] = useState(false);
  const [paymentActionMessage, setPaymentActionMessage] = useState(null);
  const [paymentActionMessageType, setPaymentActionMessageType] = useState("error");

  // ─── ENGINEER FORM STATE (COMPLETE SCHEMA) ──────────────────
  const emptyForm = {
    name: "",
    email: "",
    phoneNumber: "",
    password: "",
    address: "",
    designation: "",
    dateOfJoining: "",
    lastWorkingDate: "",
    dateOfBirth: "",
    salaryPerMonth: "",
    salaryPerDay: "",
    welfareAmount: "",
    emergencyContact: "",
    aadharNumber: "",
    panNumber: "",
    bloodGroup: "",
    engineerStatus: "WORKING",
  };

  const [formData, setFormData] = useState(emptyForm);
  const [aadharFile, setAadharFile] = useState(null);
  const [resumeFile, setResumeFile] = useState(null);

  // ─── HELPERS ─────────────────────────────────────────────────
  const initials = (name = "") =>
    name.trim().split(" ").slice(0, 2).map((w) => w[0]?.toUpperCase() || "").join("");

  const filteredList = engineerList.filter((e) => {
    const matchesSearch =
      (e.name || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
      (e.email || "").toLowerCase().includes(searchQuery.toLowerCase());
    const matchesStatus = statusFilter === "ALL" || e.engineerStatus === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const stats = {
    total: engineerList.length,
    active: engineerList.filter((e) => e.engineerStatus === "WORKING").length,
    designations: new Set(engineerList.map((e) => e.designation).filter(Boolean)).size,
  };

  const statusLabel = (status) => {
    if (!status || status === "WORKING") return "Working";
    return status.replace("NOT_WORKING_", "").replace(/_/g, " ");
  };

  const formatStatus = (status) => (status ? status.replace(/_/g, " ") : "-");

  const formatCurrency = (value) => {
    return (value || 0).toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
    });
  };

  const monthName = (month) => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return months[month - 1] || "";
  };

  // ─── FORM HANDLERS ───────────────────────────────────────────
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const resetForm = () => {
    setFormData(emptyForm);
    setAadharFile(null);
    setResumeFile(null);
    setEditEngineerId(null);
    setDrawerOpen(false);
  };

  useEffect(() => {
    if (formData.lastWorkingDate) {
      setFormData((prev) => ({ ...prev, engineerStatus: "NOT_WORKING_RESIGNED" }));
    }
  }, [formData.lastWorkingDate]);

  const buildRegisterFormData = () => {
    const data = new FormData();
    const dto = {};

    Object.keys(formData).forEach((key) => {
      if (formData[key] !== "" && formData[key] !== null && formData[key] !== undefined) {
        // Convert number fields to numbers
        if (["salaryPerMonth", "salaryPerDay", "welfareAmount"].includes(key)) {
          dto[key] = parseFloat(formData[key]) || 0;
        } else {
          dto[key] = formData[key];
        }
      }
    });

    data.append("engineerDto", new Blob([JSON.stringify(dto)], { type: "application/json" }));
    if (aadharFile) data.append("aadharCardImg", aadharFile);
    if (resumeFile) data.append("resume", resumeFile);
    return data;
  };

  const buildUpdateFormData = () => {
    const data = new FormData();
    const { engineerStatus, ...rest } = formData;
    const dto = {};

    Object.keys(rest).forEach((key) => {
      if (rest[key] !== "" && rest[key] !== null && rest[key] !== undefined) {
        // Convert number fields to numbers
        if (["salaryPerMonth", "salaryPerDay", "welfareAmount"].includes(key)) {
          dto[key] = parseFloat(rest[key]) || 0;
        } else {
          dto[key] = rest[key];
        }
      }
    });

    data.append("request", new Blob([JSON.stringify(dto)], { type: "application/json" }));
    data.append("engineerStatus", new Blob([JSON.stringify(engineerStatus)], { type: "application/json" }));
    if (aadharFile) data.append("aadharCardImg", aadharFile);
    if (resumeFile) data.append("resume", resumeFile);
    return data;
  };

  // ─── API CALLS ───────────────────────────────────────────────
  async function getEngineerList() {
    try {
      const response = await axiosInstance.get(`${BASE_URL}/allEngineers`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setEngineerList(response.data.sort((a, b) => b.id - a.id));
    } catch (error) {
      console.error("Failed to fetch engineers:", error);
    } finally {
      setLoading(false);
    }
  }

  async function fetchEngineerById(id) {
    try {
      const response = await axiosInstance.get(`${BASE_URL}/engineer/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      console.error("Failed to fetch engineer:", error);
      alert("Failed to fetch engineer details");
      return null;
    }
  }

  // ─── PAYMENT MANAGEMENT OPERATIONS ──────────────────────────
  async function openPaymentsModal() {
    setPaymentsModal(true);
    setPaymentsData([]);
    setPaymentsLoading(true);
    setPaymentActionMessage(null);

    const result = await paymentService.getPaymentsByMonthYear(selectedMonth, selectedYear);
    if (result.success) {
      setPaymentsData(result.data);
    } else {
      alert(result.message);
      setPaymentsModal(false);
    }
    setPaymentsLoading(false);
  }

  async function handleMonthYearChange() {
    setPaymentsData([]);
    setPaymentsLoading(true);
    setPaymentActionMessage(null);

    const result = await paymentService.getPaymentsByMonthYear(selectedMonth, selectedYear);
    if (result.success) {
      setPaymentsData(result.data);
    } else {
      alert(result.message);
    }
    setPaymentsLoading(false);
  }

  // ─── PAYMENT EDIT OPERATIONS ────────────────────────────────
  function openPaymentEditModal(payment) {
    setPaymentEditModal({
      paymentId: payment.paymentId,
      engineerName: payment.engineerName,
      paymentMonth: `${monthName(payment.month)} ${payment.year}`,
      currentData: {
        basicSalary: payment.basicSalary || 0,
        petrolAllowance: payment.petrolAllowance || 0,
        absentDeduction: payment.absentDeduction || 0,
        halfDayDeduction: payment.halfDayDeduction || 0,
        lateDayDeduction: payment.lateDayDeduction || 0,
        advanceDeduction: payment.advanceDeduction || 0,
        welfareDeduction: payment.welfareDeduction || 0,
        totalDeduction: payment.totalDeduction || 0,
        netPay: payment.netPay || 0,
        originalNetPay: payment.originalNetPay || 0,
        status: payment.status,
        isEdited: payment.isEdited,
        editRemark: payment.editRemark || "",
        editedBy: payment.editedBy || "",
      },
    });
    setPaymentEditData({
      petrolAllowance: payment.petrolAllowance || 0,
      lateDayDeduction: payment.lateDayDeduction || 0,
      advanceDeduction: payment.advanceDeduction || 0,
      editRemark: payment.editRemark || "",
    });
    setPaymentActionMessage(null);
  }

  async function handlePaymentEdit() {
    setPaymentEditLoading(true);
    setPaymentActionMessage(null);

    const result = await paymentService.editPayment(
      paymentEditModal.paymentId,
      paymentEditData,
      adminUsername
    );

    if (result.success) {
      setPaymentActionMessageType("success");
      setPaymentActionMessage("Payment updated successfully");
      setTimeout(() => {
        setPaymentEditModal(null);
        setPaymentActionMessage(null);
        handleMonthYearChange();
      }, 1500);
    } else {
      setPaymentActionMessageType("error");
      setPaymentActionMessage(result.message);
    }
    setPaymentEditLoading(false);
  }

  async function handleMarkPaymentAsPaid() {
    const confirmed = window.confirm(
      `Mark this payment as PAID?\n\nPayment ID: ${paymentEditModal.paymentId}\nMonth: ${paymentEditModal.paymentMonth}`
    );
    if (!confirmed) return;

    setPaymentMarkPaidLoading(true);
    setPaymentActionMessage(null);

    const result = await paymentService.markPaymentAsPaid(
      paymentEditModal.paymentId,
      adminUsername
    );

    if (result.success) {
      setPaymentActionMessageType("success");
      setPaymentActionMessage("Payment marked as paid successfully");
      setTimeout(() => {
        setPaymentEditModal(null);
        setPaymentActionMessage(null);
        handleMonthYearChange();
      }, 1500);
    } else {
      setPaymentActionMessageType("error");
      setPaymentActionMessage(result.message);
    }
    setPaymentMarkPaidLoading(false);
  }

  // ─── OTHER OPERATIONS ───────────────────────────────────────
  async function handleAddEngineer(e) {
    e.preventDefault();
    setSubmitting(true);
    try {
      const response = await axiosInstance.post(
        `${BASE_URL}/registerEngineer`,
        buildRegisterFormData(),
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
      );
      if (response.status === 200) {
        alert("Engineer Registered Successfully");
        resetForm();
        getEngineerList();
      }
    } catch (error) {
      let message = "Something went wrong";
      if (error.response) {
        const { status, data } = error.response;
        if (status === 409) message = data?.message || "Email already exists";
        else if (status === 400) message = data?.message || "Invalid data";
        else if (status === 401) message = "Unauthorized. Please login again.";
        else if (status === 500) message = data?.message || "Server error. Try again later.";
        else message = data?.message || `Error: ${status}`;
      } else if (error.request) {
        message = "No response from server. Check your connection.";
      } else {
        message = error.message;
      }
      alert(message);
    } finally {
      setSubmitting(false);
    }
  }

  async function handleEditEngineerRegistration(e) {
    e.preventDefault();
    setSubmitting(true);
    try {
      const response = await axiosInstance.put(
        `${BASE_URL}/engineer/update/${editEngineerId}`,
        buildUpdateFormData(),
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
      );
      if (response.status === 200) {
        alert("Engineer Updated Successfully");
        resetForm();
        getEngineerList();
      }
    } catch (error) {
      alert(error?.response?.data?.message || "Update failed");
    } finally {
      setSubmitting(false);
    }
  }

  async function handleDeleteEngineer() {
    setDeleteSubmitting(true);
    try {
      const response = await axiosInstance.delete(
        `${BASE_URL}/deleteEngineer/${deleteModal.id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.status === 200) {
        alert("Engineer Deleted Successfully");
        setDeleteModal(null);
        getEngineerList();
      }
    } catch (error) {
      alert(error?.response?.data?.message || "Delete failed");
    } finally {
      setDeleteSubmitting(false);
    }
  }

  function openStatusModal(eng) {
    setStatusModal({ id: eng.id, name: eng.name });
    setSelectedStatus(eng.engineerStatus || "WORKING");
  }

  async function handleStatusUpdate() {
    setStatusSubmitting(true);
    try {
      const response = await axiosInstance.patch(
        `${BASE_URL}/engineer/update/${statusModal.id}/status?engineerStatus=${selectedStatus}`,
        null,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.status === 200) {
        alert("Status Updated Successfully");
        setStatusModal(null);
        getEngineerList();
      }
    } catch (error) {
      alert(error?.response?.data?.message || "Status update failed");
    } finally {
      setStatusSubmitting(false);
    }
  }

  async function openEditDrawer(engineer) {
    const data = await fetchEngineerById(engineer.id);
    if (!data) return;
    setEditEngineerId(data.id);
    setFormData({
      name: data.name || "",
      email: data.email || "",
      phoneNumber: data.phoneNumber || "",
      password: "",
      address: data.address || "",
      designation: data.designation || "",
      dateOfJoining: data.dateOfJoining || "",
      lastWorkingDate: data.lastWorkingDate || "",
      dateOfBirth: data.dateOfBirth || "",
      salaryPerMonth: data.salaryPerMonth != null ? String(data.salaryPerMonth) : "",
      salaryPerDay: data.salaryPerDay != null ? String(data.salaryPerDay) : "",
      welfareAmount: data.welfareAmount != null ? String(data.welfareAmount) : "",
      emergencyContact: data.emergencyContact || "",
      aadharNumber: data.aadharNumber || "",
      panNumber: data.panNumber || "",
      bloodGroup: data.bloodGroup || "",
      engineerStatus: data.engineerStatus || "WORKING",
    });
    setDrawerOpen(true);
  }

  useEffect(() => {
    getEngineerList();
  }, []);

  // ─── RENDER ──────────────────────────────────────────────────
  return (
    <div className="eng-page">
      {/* TOP BAR */}
      <div className="eng-topbar">
        <div>
          <h2 className="eng-page-title">Engineers</h2>
          <p className="eng-page-sub">Manage your engineering team</p>
        </div>
        <div style={{ display: "flex", gap: "12px" }}>
          <button className="eng-btn-primary" onClick={openPaymentsModal}>
            💳 Payments
          </button>
          <button className="eng-btn-primary" onClick={() => { resetForm(); setDrawerOpen(true); }}>
            + Add engineer
          </button>
        </div>
      </div>

      {/* STAT CARDS */}
      <div className="eng-stats">
        <div className="eng-stat-card">
          <div className="eng-stat-label">Total engineers</div>
          <div className="eng-stat-value">{stats.total}</div>
        </div>
        <div className="eng-stat-card">
          <div className="eng-stat-label">Active</div>
          <div className="eng-stat-value eng-stat-green">{stats.active}</div>
        </div>
        <div className="eng-stat-card">
          <div className="eng-stat-label">Designations</div>
          <div className="eng-stat-value">{stats.designations}</div>
        </div>
      </div>

      {/* TABLE */}
      <div className="eng-table-card">
        <div className="eng-table-header">
          <span className="eng-table-title">Team roster</span>
          <div className="eng-filter-wrapper">
            <select
              className="eng-status-filter"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="ALL">All Status</option>
              <option value="WORKING">Working</option>
              <option value="NOT_WORKING_RESIGNED">Resigned</option>
              <option value="NOT_WORKING_TERMINATED">Terminated</option>
              <option value="NOT_WORKING_RETIRED">Retired</option>
            </select>
            <span className="eng-filter-icon">⌄</span>
          </div>
          <div className="eng-table-controls">
            <input
              className="eng-search"
              placeholder="Search by name or email…"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>

        {loading ? (
          <div className="eng-empty">Loading engineers…</div>
        ) : filteredList.length === 0 ? (
          <div className="eng-empty">No engineers found.</div>
        ) : (
          <table className="eng-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Designation</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredList.map((eng) => (
                <tr key={eng.id}>
                  <td>
                    <div className="eng-name-cell">
                      <div className="eng-avatar">{initials(eng.name)}</div>
                      <span>{eng.name || "—"}</span>
                    </div>
                  </td>
                  <td className="eng-muted">{eng.email || "—"}</td>
                  <td>{eng.phoneNumber || "—"}</td>
                  <td className="eng-muted">{eng.designation || "—"}</td>
                  <td>
                    <span className={`eng-badge ${eng.engineerStatus === "WORKING" ? "eng-badge-active" : "eng-badge-inactive"}`}>
                      {statusLabel(eng.engineerStatus)}
                    </span>
                  </td>
                  <td>
                    <div className="eng-action-btns">
                      <button className="eng-btn-ghost eng-btn-sm" onClick={() => openEditDrawer(eng)}>
                        Edit
                      </button>
                      <button className="eng-btn-status eng-btn-sm" onClick={() => openStatusModal(eng)}>
                        Status
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* PAYMENTS MANAGEMENT MODAL */}
      {paymentsModal && (
        <div
          style={{
            position: "fixed", inset: 0,
            background: "rgba(0,0,0,0.45)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 999,
          }}
          onClick={() => setPaymentsModal(false)}
        >
          <div
            style={{
              background: "#fff", borderRadius: "12px",
              padding: "1.5rem", width: "95%", maxWidth: "1100px",
              maxHeight: "85vh", overflowY: "auto",
              boxShadow: "0 4px 24px rgba(0,0,0,0.15)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.5rem" }}>
              <div>
                <h3 style={{ margin: 0, fontSize: "18px" }}>Payment Management</h3>
                <p style={{ fontSize: "13px", color: "#666", margin: "4px 0 0" }}>
                  View, edit, and manage all engineer payments
                </p>
              </div>
              <button
                className="eng-btn-ghost"
                onClick={() => setPaymentsModal(false)}
                style={{ fontSize: "20px", padding: "4px 8px" }}
              >
                ✕
              </button>
            </div>

            {/* Month/Year Filter */}
            <div style={{
              display: "flex", gap: "12px", marginBottom: "1.5rem",
              alignItems: "flex-end", background: "#f9f9f7", padding: "16px", borderRadius: "8px",
            }}>
              <div>
                <label style={{ fontSize: "13px", fontWeight: 500, display: "block", marginBottom: "6px", color: "#333" }}>
                  Month
                </label>
                <select
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(Number(e.target.value))}
                  style={{
                    padding: "8px 12px", fontSize: "13px", border: "1px solid #ddd",
                    borderRadius: "6px", background: "#fff", minWidth: "120px",
                  }}
                >
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((m) => (
                    <option key={m} value={m}>{monthName(m)}</option>
                  ))}
                </select>
              </div>

              <div>
                <label style={{ fontSize: "13px", fontWeight: 500, display: "block", marginBottom: "6px", color: "#333" }}>
                  Year
                </label>
                <select
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(Number(e.target.value))}
                  style={{
                    padding: "8px 12px", fontSize: "13px", border: "1px solid #ddd",
                    borderRadius: "6px", background: "#fff", minWidth: "100px",
                  }}
                >
                  {[2024, 2025, 2026, 2027].map((y) => (
                    <option key={y} value={y}>{y}</option>
                  ))}
                </select>
              </div>

              <button
                className="eng-btn-primary"
                onClick={handleMonthYearChange}
                disabled={paymentsLoading}
                style={{ padding: "8px 16px", fontSize: "13px" }}
              >
                {paymentsLoading ? "Loading..." : "Load Payments"}
              </button>
            </div>

            {/* Payments Summary */}
            {!paymentsLoading && paymentsData.length > 0 && (
              <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "12px", marginBottom: "1.5rem" }}>
                <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "12px" }}>
                  <p style={{ fontSize: "11px", color: "#888", margin: "0 0 4px" }}>Total Payable</p>
                  <p style={{ fontSize: "16px", fontWeight: 600, margin: 0 }}>
                    {formatCurrency(paymentsData.reduce((sum, p) => sum + (p.basicSalary || 0), 0))}
                  </p>
                </div>
                <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "12px" }}>
                  <p style={{ fontSize: "11px", color: "#888", margin: "0 0 4px" }}>Total Deductions</p>
                  <p style={{ fontSize: "16px", fontWeight: 600, margin: 0, color: "#e53935" }}>
                    {formatCurrency(paymentsData.reduce((sum, p) => sum + (p.totalDeduction || 0), 0))}
                  </p>
                </div>
                <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "12px" }}>
                  <p style={{ fontSize: "11px", color: "#888", margin: "0 0 4px" }}>Total Net Pay</p>
                  <p style={{ fontSize: "16px", fontWeight: 600, margin: 0, color: "#2e7d32" }}>
                    {formatCurrency(paymentsData.reduce((sum, p) => sum + (p.netPay || 0), 0))}
                  </p>
                </div>
              </div>
            )}

            {/* Payments Table */}
            {paymentsLoading ? (
              <div style={{ textAlign: "center", padding: "2rem", color: "#888" }}>Loading payments...</div>
            ) : paymentsData.length === 0 ? (
              <div style={{ textAlign: "center", padding: "2rem", color: "#888" }}>No payments found for this month.</div>
            ) : (
              <div style={{ overflowX: "auto" }}>
                <table className="eng-table">
                  <thead>
                    <tr>
                      <th>Engineer</th>
                      <th>Designation</th>
                      <th>Basic</th>
                      <th>Deductions</th>
                      <th>Net Pay</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paymentsData.map((payment) => (
                      <tr key={payment.paymentId}>
                        <td style={{ fontWeight: 500 }}>{payment.engineerName}</td>
                        <td style={{ fontSize: "13px", color: "#666" }}>—</td>
                        <td>{formatCurrency(payment.basicSalary)}</td>
                        <td style={{ color: "#e53935", fontWeight: 500 }}>
                          {formatCurrency(payment.totalDeduction)}
                        </td>
                        <td style={{ color: "#2e7d32", fontWeight: 500 }}>
                          {formatCurrency(payment.netPay)}
                        </td>
                        <td>
                          <span className={`eng-badge ${payment.status === "PAID" ? "eng-badge-active" : "eng-badge-inactive"}`}>
                            {formatStatus(payment.status)}
                          </span>
                        </td>
                        <td>
                          <button
                            className="eng-btn-ghost eng-btn-sm"
                            onClick={() => openPaymentEditModal(payment)}
                            title="Edit payment deductions"
                          >
                            ✎ Edit
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}

      {/* PAYMENT EDIT MODAL */}
      {paymentEditModal && (
        <div
          style={{
            position: "fixed", inset: 0,
            background: "rgba(0,0,0,0.45)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 1000,
          }}
          onClick={() => setPaymentEditModal(null)}
        >
          <div
            style={{
              background: "#fff", borderRadius: "12px",
              padding: "1.5rem", width: "95%", maxWidth: "560px",
              boxShadow: "0 4px 24px rgba(0,0,0,0.15)",
              maxHeight: "90vh", overflowY: "auto",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.5rem" }}>
              <div>
                <h3 style={{ margin: 0, fontSize: "18px" }}>Edit Payment</h3>
                <p style={{ fontSize: "13px", color: "#666", margin: "4px 0 0" }}>
                  {paymentEditModal.engineerName} • {paymentEditModal.paymentMonth}
                </p>
              </div>
              <button
                className="eng-btn-ghost"
                onClick={() => setPaymentEditModal(null)}
                style={{ fontSize: "20px", padding: "4px 8px" }}
              >
                ✕
              </button>
            </div>

            {/* Current Payment Summary */}
            <div style={{
              background: "#f9f9f7", borderRadius: "8px", padding: "16px",
              marginBottom: "1.5rem", border: "1px solid #ebebeb",
            }}>
              <h4 style={{ margin: "0 0 12px", fontSize: "13px", textTransform: "uppercase", color: "#666", letterSpacing: "0.5px" }}>
                Current Payment Details
              </h4>
              <div style={{
                display: "grid", gridTemplateColumns: "1fr 1fr",
                gap: "12px", fontSize: "13px",
              }}>
                <div>
                  <p style={{ color: "#888", fontSize: "11px", margin: "0 0 2px" }}>Basic Salary</p>
                  <p style={{ fontWeight: 600, margin: 0 }}>₹ {(paymentEditModal.currentData.basicSalary || 0).toLocaleString("en-IN")}</p>
                </div>
                <div>
                  <p style={{ color: "#888", fontSize: "11px", margin: "0 0 2px" }}>Total Deduction</p>
                  <p style={{ fontWeight: 600, margin: 0, color: "#e53935" }}>₹ {(paymentEditModal.currentData.totalDeduction || 0).toLocaleString("en-IN")}</p>
                </div>
                <div>
                  <p style={{ color: "#888", fontSize: "11px", margin: "0 0 2px" }}>Original Net Pay</p>
                  <p style={{ fontWeight: 600, margin: 0 }}>₹ {(paymentEditModal.currentData.originalNetPay || 0).toLocaleString("en-IN")}</p>
                </div>
                <div>
                  <p style={{ color: "#888", fontSize: "11px", margin: "0 0 2px" }}>Current Net Pay</p>
                  <p style={{ fontWeight: 600, margin: 0, color: "#2e7d32" }}>₹ {(paymentEditModal.currentData.netPay || 0).toLocaleString("en-IN")}</p>
                </div>
              </div>

              {paymentEditModal.currentData.isEdited && (
                <div style={{ marginTop: "12px", paddingTop: "12px", borderTop: "1px solid #ddd", fontSize: "12px", color: "#f57c00" }}>
                  <strong>⚠ This payment has been previously edited</strong>
                  {paymentEditModal.currentData.editRemark && (
                    <p style={{ margin: "4px 0 0", color: "#666" }}>
                      <strong>Previous remark:</strong> {paymentEditModal.currentData.editRemark}
                    </p>
                  )}
                  {paymentEditModal.currentData.editedBy && (
                    <p style={{ margin: "4px 0 0", color: "#666" }}>
                      <strong>Edited by:</strong> {paymentEditModal.currentData.editedBy}
                    </p>
                  )}
                </div>
              )}
            </div>

            {/* Edit Form */}
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handlePaymentEdit();
              }}
              style={{ marginBottom: "1.5rem" }}
            >
              <h4 style={{ margin: "0 0 16px", fontSize: "13px", textTransform: "uppercase", color: "#666", letterSpacing: "0.5px" }}>
                Edit Deductions & Allowances
              </h4>

              <div style={{ marginBottom: "16px" }}>
                <label style={{ fontSize: "13px", fontWeight: 500, color: "#333", display: "block", marginBottom: "6px" }}>
                  Petrol Allowance (₹)
                </label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  value={paymentEditData.petrolAllowance}
                  onChange={(e) =>
                    setPaymentEditData((prev) => ({
                      ...prev,
                      petrolAllowance: parseFloat(e.target.value) || 0,
                    }))
                  }
                  style={{
                    width: "100%", padding: "10px 12px", fontSize: "13px",
                    border: "1px solid #ddd", borderRadius: "6px", boxSizing: "border-box",
                  }}
                />
              </div>

              <div style={{ marginBottom: "16px" }}>
                <label style={{ fontSize: "13px", fontWeight: 500, color: "#333", display: "block", marginBottom: "6px" }}>
                  Late Day Deduction (₹)
                </label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  value={paymentEditData.lateDayDeduction}
                  onChange={(e) =>
                    setPaymentEditData((prev) => ({
                      ...prev,
                      lateDayDeduction: parseFloat(e.target.value) || 0,
                    }))
                  }
                  style={{
                    width: "100%", padding: "10px 12px", fontSize: "13px",
                    border: "1px solid #ddd", borderRadius: "6px", boxSizing: "border-box",
                  }}
                />
              </div>

              <div style={{ marginBottom: "16px" }}>
                <label style={{ fontSize: "13px", fontWeight: 500, color: "#333", display: "block", marginBottom: "6px" }}>
                  Advance Deduction (₹)
                </label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  value={paymentEditData.advanceDeduction}
                  onChange={(e) =>
                    setPaymentEditData((prev) => ({
                      ...prev,
                      advanceDeduction: parseFloat(e.target.value) || 0,
                    }))
                  }
                  style={{
                    width: "100%", padding: "10px 12px", fontSize: "13px",
                    border: "1px solid #ddd", borderRadius: "6px", boxSizing: "border-box",
                  }}
                />
              </div>

              <div style={{ marginBottom: "20px" }}>
                <label style={{ fontSize: "13px", fontWeight: 500, color: "#333", display: "block", marginBottom: "6px" }}>
                  Edit Remark
                </label>
                <textarea
                  value={paymentEditData.editRemark}
                  onChange={(e) =>
                    setPaymentEditData((prev) => ({
                      ...prev,
                      editRemark: e.target.value,
                    }))
                  }
                  placeholder="Reason for editing this payment..."
                  style={{
                    width: "100%", padding: "10px 12px", fontSize: "13px",
                    border: "1px solid #ddd", borderRadius: "6px", boxSizing: "border-box",
                    fontFamily: "inherit", resize: "vertical", minHeight: "60px",
                  }}
                />
              </div>

              {/* Action Messages */}
              {paymentActionMessage && (
                <div
                  style={{
                    padding: "12px 16px", borderRadius: "8px", marginBottom: "16px", fontSize: "13px",
                    background: paymentActionMessageType === "success" ? "#e6f4ea" : "#fff3f3",
                    color: paymentActionMessageType === "success" ? "#2e7d32" : "#e53935",
                    border: `1px solid ${paymentActionMessageType === "success" ? "#c6e9c9" : "#ffcdd2"}`,
                  }}
                >
                  {paymentActionMessage}
                </div>
              )}

              {/* Buttons */}
              <div style={{ display: "flex", gap: "12px" }}>
                <button
                  type="submit"
                  className="eng-btn-primary"
                  style={{ flex: 1 }}
                  disabled={paymentEditLoading}
                >
                  {paymentEditLoading ? "Updating..." : "Update Payment"}
                </button>
                <button
                  type="button"
                  className="eng-btn-status eng-btn-sm"
                  onClick={handleMarkPaymentAsPaid}
                  disabled={paymentMarkPaidLoading || paymentEditModal.currentData.status === "PAID"}
                  style={{
                    padding: "10px 16px", fontSize: "13px", opacity:
                      paymentEditModal.currentData.status === "PAID" ? 0.5 : 1,
                  }}
                  title={paymentEditModal.currentData.status === "PAID" ? "Already marked as paid" : "Mark as paid"}
                >
                  {paymentMarkPaidLoading ? "Marking..." : "Mark Paid"}
                </button>
              </div>
            </form>

            <div style={{ borderTop: "1px solid #ebebeb", paddingTop: "12px" }}>
              <button
                className="eng-btn-ghost"
                onClick={() => setPaymentEditModal(null)}
                style={{ width: "100%" }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* DELETE CONFIRM MODAL */}
      {deleteModal && (
        <div className="eng-modal-overlay" onClick={() => setDeleteModal(null)}>
          <div className="eng-modal" onClick={(e) => e.stopPropagation()}>
            <div className="eng-modal-header">
              <h3 className="eng-modal-title">Delete Engineer</h3>
              <button className="eng-close-btn" onClick={() => setDeleteModal(null)}>✕</button>
            </div>
            <p className="eng-modal-name" style={{ marginBottom: 8 }}>
              Are you sure you want to delete <strong>{deleteModal.name}</strong>?
            </p>
            <p style={{ fontSize: 13, color: "var(--eng-muted, #6b7280)", marginBottom: 20 }}>
              This action cannot be undone.
            </p>
            <div className="eng-modal-actions">
              <button
                className="eng-btn-delete-confirm"
                style={{ flex: 1 }}
                onClick={handleDeleteEngineer}
                disabled={deleteSubmitting}
              >
                {deleteSubmitting ? "Deleting…" : "Yes, Delete"}
              </button>
              <button className="eng-btn-ghost" onClick={() => setDeleteModal(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* STATUS MODAL */}
      {statusModal && (
        <div className="eng-modal-overlay" onClick={() => setStatusModal(null)}>
          <div className="eng-modal" onClick={(e) => e.stopPropagation()}>
            <div className="eng-modal-header">
              <h3 className="eng-modal-title">Update Status</h3>
              <button className="eng-close-btn" onClick={() => setStatusModal(null)}>✕</button>
            </div>
            <p className="eng-modal-name">{statusModal.name}</p>
            <div className="eng-status-options">
              {[
                { value: "WORKING", label: "Working" },
                { value: "NOT_WORKING_RESIGNED", label: "Resigned" },
                { value: "NOT_WORKING_TERMINATED", label: "Terminated" },
                { value: "NOT_WORKING_RETIRED", label: "Retired" },
              ].map((opt) => (
                <label key={opt.value} className={`eng-status-option ${selectedStatus === opt.value ? "selected" : ""}`}>
                  <input
                    type="radio"
                    name="statusPick"
                    value={opt.value}
                    checked={selectedStatus === opt.value}
                    onChange={() => setSelectedStatus(opt.value)}
                  />
                  <span className={`eng-badge ${opt.value === "WORKING" ? "eng-badge-active" : "eng-badge-inactive"}`}>
                    {opt.label}
                  </span>
                </label>
              ))}
            </div>
            <div className="eng-modal-actions">
              <button
                className="eng-btn-primary"
                style={{ flex: 1 }}
                onClick={handleStatusUpdate}
                disabled={statusSubmitting}
              >
                {statusSubmitting ? "Saving…" : "Update Status"}
              </button>
              <button className="eng-btn-ghost" onClick={() => setStatusModal(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* ENGINEER REGISTRATION/UPDATE DRAWER */}
      {drawerOpen && (
        <div className="eng-overlay" onClick={resetForm}>
          <div className="eng-drawer" onClick={(e) => e.stopPropagation()}>
            <div className="eng-drawer-header">
              <h3 className="eng-drawer-title">
                {editEngineerId ? "Update engineer" : "Register engineer"}
              </h3>
              <button className="eng-close-btn" onClick={resetForm}>✕</button>
            </div>

            <form onSubmit={editEngineerId ? handleEditEngineerRegistration : handleAddEngineer}>
              {/* BASIC INFORMATION */}
              <div className="eng-section-label">Basic Information</div>
              <div className="eng-form-row">
                <div className="eng-form-group">
                  <label>Full Name *</label>
                  <input
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Rahul Sharma"
                    required
                  />
                </div>
                <div className="eng-form-group">
                  <label>Email *</label>
                  <input
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="rahul@company.com"
                    required
                  />
                </div>
              </div>

              <div className="eng-form-row">
                <div className="eng-form-group">
                  <label>Phone Number *</label>
                  <input
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                    placeholder="+91 98765 43210"
                    required
                  />
                </div>
                {!editEngineerId && (
                  <div className="eng-form-group">
                    <label>Password *</label>
                    <input
                      name="password"
                      type="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="••••••••"
                      required
                    />
                  </div>
                )}
              </div>

              <div className="eng-form-row">
                <div className="eng-form-group">
                  <label>Address</label>
                  <input
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    placeholder="123, Main Street, Nagpur"
                  />
                </div>
              </div>

              {/* EMPLOYMENT DETAILS */}
              <div className="eng-section-label">Employment Details</div>
              <div className="eng-form-row">
                <div className="eng-form-group">
                  <label>Designation</label>
                  <input
                    name="designation"
                    value={formData.designation}
                    onChange={handleChange}
                    placeholder="Site Engineer"
                  />
                </div>
                <div className="eng-form-group">
                  <label>Date of Joining</label>
                  <input
                    name="dateOfJoining"
                    type="date"
                    value={formData.dateOfJoining}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="eng-form-row">
                <div className="eng-form-group">
                  <label>Last Working Date</label>
                  <input
                    name="lastWorkingDate"
                    type="date"
                    value={formData.lastWorkingDate}
                    onChange={handleChange}
                  />
                </div>
                <div className="eng-form-group">
                  <label>Status</label>
                  <select
                    name="engineerStatus"
                    value={formData.engineerStatus}
                    onChange={handleChange}
                  >
                    <option value="WORKING">Working</option>
                    <option value="NOT_WORKING_RESIGNED">Resigned</option>
                    <option value="NOT_WORKING_TERMINATED">Terminated</option>
                    <option value="NOT_WORKING_RETIRED">Retired</option>
                  </select>
                </div>
              </div>

              {/* SALARY INFORMATION */}
              <div className="eng-section-label">Salary Information</div>
              <div className="eng-form-row">
                <div className="eng-form-group">
                  <label>Salary Per Month (₹)</label>
                  <input
                    name="salaryPerMonth"
                    type="number"
                    value={formData.salaryPerMonth}
                    onChange={handleChange}
                    placeholder="35000"
                    min="0"
                  />
                </div>
                <div className="eng-form-group">
                  <label>Salary Per Day (₹)</label>
                  <input
                    name="salaryPerDay"
                    type="number"
                    value={formData.salaryPerDay}
                    onChange={handleChange}
                    placeholder="1500"
                    min="0"
                  />
                </div>
              </div>

              <div className="eng-form-row">
                <div className="eng-form-group">
                  <label>Welfare Amount (₹)</label>
                  <input
                    name="welfareAmount"
                    type="number"
                    value={formData.welfareAmount}
                    onChange={handleChange}
                    placeholder="0"
                    min="0"
                  />
                </div>
              </div>

              {/* PERSONAL DETAILS */}
              <div className="eng-section-label">Personal Details</div>
              <div className="eng-form-row">
                <div className="eng-form-group">
                  <label>Date of Birth</label>
                  <input
                    name="dateOfBirth"
                    type="date"
                    value={formData.dateOfBirth}
                    onChange={handleChange}
                  />
                </div>
                <div className="eng-form-group">
                  <label>Blood Group</label>
                  <input
                    name="bloodGroup"
                    value={formData.bloodGroup}
                    onChange={handleChange}
                    placeholder="B+"
                  />
                </div>
              </div>

              <div className="eng-form-row">
                <div className="eng-form-group">
                  <label>Emergency Contact</label>
                  <input
                    name="emergencyContact"
                    value={formData.emergencyContact}
                    onChange={handleChange}
                    placeholder="+91 ..."
                  />
                </div>
              </div>

              {/* IDENTITY DOCUMENTS */}
              <div className="eng-section-label">Identity Documents</div>
              <div className="eng-form-row">
                <div className="eng-form-group">
                  <label>Aadhar Number</label>
                  <input
                    name="aadharNumber"
                    value={formData.aadharNumber}
                    onChange={handleChange}
                    placeholder="1234 5678 9012"
                  />
                </div>
                <div className="eng-form-group">
                  <label>PAN Number</label>
                  <input
                    name="panNumber"
                    value={formData.panNumber}
                    onChange={handleChange}
                    placeholder="ABCDE1234F"
                  />
                </div>
              </div>

              {/* FILE UPLOADS */}
              <div className="eng-section-label">Documents</div>
              <div className="eng-form-row">
                <div className="eng-form-group">
                  <label>Aadhar Card (Image)</label>
                  <label className="eng-file-upload">
                    <span>{aadharFile ? aadharFile.name : "Choose file"}</span>
                    <input
                      type="file"
                      style={{ display: "none" }}
                      onChange={(e) => setAadharFile(e.target.files[0])}
                      accept="image/*"
                    />
                  </label>
                </div>
                <div className="eng-form-group">
                  <label>Resume (PDF/DOC)</label>
                  <label className="eng-file-upload">
                    <span>{resumeFile ? resumeFile.name : "Choose file"}</span>
                    <input
                      type="file"
                      style={{ display: "none" }}
                      onChange={(e) => setResumeFile(e.target.files[0])}
                      accept=".pdf,.doc,.docx"
                    />
                  </label>
                </div>
              </div>

              {/* FORM ACTIONS */}
              <div className="eng-form-actions">
                <button
                  type="submit"
                  className="eng-btn-primary"
                  style={{ flex: 1 }}
                  disabled={submitting}
                >
                  {submitting ? "Saving…" : editEngineerId ? "Save Changes" : "Register Engineer"}
                </button>
                <button type="button" className="eng-btn-ghost" onClick={resetForm}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// ROOT EXPORT — routes to the admin dashboard or the self-profile view based
// on role, with a tab switcher for the (presumably rare) case where someone
// holds both an ENGINEER role and an admin-type role at once.
// ─────────────────────────────────────────────────────────────────────────────
function Engineer() {
  const storedUser = getStoredUser();
  const roleNames = getRoleNames(storedUser);
  const isAdmin = roleNames.some((r) => ADMIN_ROLE_VARIANTS.includes(r));
  const isEngineerRole = roleNames.includes("ENGINEER");
  const selfEngineerId = storedUser.engineerId || storedUser.id;

  const [activeView, setActiveView] = useState(isAdmin ? "team" : "self");

  if (!isAdmin && !isEngineerRole) {
    return (
      <div className="eng-page">
        <div className="eng-empty">Your account role doesn't have access to this page.</div>
      </div>
    );
  }

  const showTabs = isAdmin && isEngineerRole;

  return (
    <div>
      {showTabs && (
        <div className="eng-page" style={{ paddingBottom: 0 }}>
          <div style={{ display: "flex", gap: 8, borderBottom: "1px solid #e5e7eb", marginBottom: "1.25rem" }}>
            <button
              onClick={() => setActiveView("team")}
              style={{
                background: "none", border: "none",
                borderBottom: activeView === "team" ? "2px solid #185fa5" : "2px solid transparent",
                color: activeView === "team" ? "#185fa5" : "#6b7280",
                fontWeight: 600, fontSize: 14, padding: "10px 4px", marginRight: 20, cursor: "pointer",
              }}
            >
              Team
            </button>
            <button
              onClick={() => setActiveView("self")}
              style={{
                background: "none", border: "none",
                borderBottom: activeView === "self" ? "2px solid #185fa5" : "2px solid transparent",
                color: activeView === "self" ? "#185fa5" : "#6b7280",
                fontWeight: 600, fontSize: 14, padding: "10px 4px", cursor: "pointer",
              }}
            >
              My Profile
            </button>
          </div>
        </div>
      )}

      {isAdmin && (!showTabs || activeView === "team") && <AdminEngineerDashboard />}
      {isEngineerRole && (!showTabs || activeView === "self") && (
        <MyEngineerProfile engineerId={selfEngineerId} token={storedUser.token} />
      )}
    </div>
  );
}

export default Engineer;